import React, { useState, useEffect, Component, useMemo, useRef, useCallback } from 'react'
import SecureShow from '../../component/SecureShow'
import "./style.css";
import { InputAdornment, TextField, Grid, Tooltip, Popover, Typography, Autocomplete, Button, IconButton, Menu, MenuItem, Box, FormControl, FormControlLabel, RadioGroup, Radio, FormLabel, InputLabel, Select } from '@mui/material';
import { IoIosSearch } from "react-icons/io";
import { IoCheckmarkCircle } from "react-icons/io5";
import { MdBlock, MdClear } from "react-icons/md";
import { RiProhibited2Line } from "react-icons/ri";
import { FaInfoCircle, FaSquareFull } from "react-icons/fa";
import { FaHashtag } from "react-icons/fa";
import { DatePicker, TimePicker, Button as ButtonMd } from 'react-md';
import CategoryModal from './Modal/CategoryModal';
import AssignmentDetailModal from './Modal/AssignmentDetailModal';
import ApiRequestService from '../../component/ApiRequestService';
import NewAssignmentModal from './Modal/NewAssignmentModal';
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import moment from 'moment';
import Toggle from 'react-toggle';
import { FiEdit, FiFile } from "react-icons/fi";
import { MdOutlineContentCut, MdOutlineContentCopy, MdOutlineContentPaste } from "react-icons/md";
import { NotificationManager } from 'react-notifications';
import { BeatLoader } from 'react-spinners';
import { confirmAlert } from 'react-confirm-alert';
import { BsInfoCircleFill } from 'react-icons/bs';
import { FaExclamation } from "react-icons/fa6";
import { DEFAULT_RANDOMIZE_CATEGORIES, NOT_REQUIRED, DEFAULT_MASTERY_COUNT, DEFAULT_MAXIMUM_ATTEMPT, DEFAULT_LOCKOUT, DEFAULT_NOCQC } from './Constants';
import CopyAllQuizDialog from '../../component/CopyAllQuizDialog';
import 'react-confirm-alert/src/react-confirm-alert.css'
import ViewRawDataModal from '../../component/ViewRawDataModal';
import { LuFileText } from "react-icons/lu";
import { FaRegCopy } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import DeleteDialog from '../DeleteDialog';
import CopyQuizDialog from '../../component/CopyQuizDialog';
import ImportAssignmentFromSemester from '../../component/ImportAssignmentFromSemester';
import { GoTrash } from "react-icons/go";
import SFTooltip from './components/SFTooltip';
import DeleteMatrixCategory from './components/DeleteMatrixCategory';
import DownloadMatrixCSV from './DownloadMatrixCSV';
import { getRandomColorForSubjectMatrix,getRandomColorForTopicMatrix,generateLabelForName } from '../../component/vectors/commonHelpers';
import SFDatePicker from '../../component/SFDatePicker';
import SFSemesterDropdown from '../../component/SFSemesterDropdown';
import { TbTargetArrow } from "react-icons/tb";
import HelpText from '../../lib/help-text';
import { BiImport } from "react-icons/bi";



const DEFAULT_ASSIGNMENT_COUNT = 14;

const SCROLL_AMOUNT = 500;

const categorySearchBarHeights = {
    small: '24px',
    medium: '24px',
    large: '32px'
};

const matrixSizeClassNames = {
    small: 'table-compact-2',
    medium: 'table-compact',
    large: ''
};

const test = [
    {
        "category_name": "Alg. operations: Division of Fractions",
        "category_label": "",
        "category_id": 16,
        "topic_id": 2,
        "subject_id": 4,
        "difficulty_level": 0.89,
        "avg_time": 4,
        "evaluate_category": 0,
        "previous_subject_id": 0,
        "previous_topic_id": 0,
        "previous_category_id": 0,
        "archive_id": 0,
        "archive_mode": false,
        "category_stats": {
            "first_attempt_accuracy": 0,
            "last_attempt_accuracy": 0,
            "first_attempt_time": 0,
            "last_attempt_time": 0,
            "first_attempt_accuracy_sd": 0,
            "last_attempt_accuracy_sd": 0,
            "first_attempt_time_sd": 0,
            "last_attempt_time_sd": 0,
            "category_name": "",
            "category_id": 0,
            "topic_id": 0,
            "subject_id": 0,
            "category_attempt": 0,
            "total_number_of_student_first_attempt": 0,
            "total_number_of_student_last_attempt": 0
        },
        "enable_sync": false,
        "new_category_id": 0,
        "university_id": 0,
        "move_category_mode": false,
        "subject_name": "",
        "topic_name": "",
        "sync_status": 0,
        "sync_validation": true,
        "is_copying": false,
        "accuracyGoal": 0,
        "timeGoal": 0,
        "currentAccuracyGoal": 0,
        "currentTimeGoal": 0,
        "previousAccuracyGoal": 0,
        "previousTimeGoal": 0,
        "non_graded": 0
    },
    {
        "category_name": "Alg. operations: Division of Fractions, Physics",
        "category_label": "Div. of Fractions Physics Context",
        "category_id": 23,
        "topic_id": 2,
        "subject_id": 4,
        "difficulty_level": 0.85,
        "avg_time": 7.5,
        "evaluate_category": 0,
        "previous_subject_id": 0,
        "previous_topic_id": 0,
        "previous_category_id": 0,
        "archive_id": 0,
        "archive_mode": false,
        "category_stats": {
            "first_attempt_accuracy": 0,
            "last_attempt_accuracy": 0,
            "first_attempt_time": 0,
            "last_attempt_time": 0,
            "first_attempt_accuracy_sd": 0,
            "last_attempt_accuracy_sd": 0,
            "first_attempt_time_sd": 0,
            "last_attempt_time_sd": 0,
            "category_name": "",
            "category_id": 0,
            "topic_id": 0,
            "subject_id": 0,
            "category_attempt": 0,
            "total_number_of_student_first_attempt": 0,
            "total_number_of_student_last_attempt": 0
        },
        "enable_sync": false,
        "new_category_id": 0,
        "university_id": 0,
        "move_category_mode": false,
        "subject_name": "",
        "topic_name": "",
        "sync_status": 0,
        "sync_validation": true,
        "is_copying": false,
        "accuracyGoal": 0,
        "timeGoal": 0,
        "currentAccuracyGoal": 0,
        "currentTimeGoal": 0,
        "previousAccuracyGoal": 0,
        "previousTimeGoal": 0,
        "non_graded": 0
    }
]

// function getColorFromIds(subject_id, topic_id) {
//     const key = `${subject_id}-${topic_id}`;
//     let hash = 0;
//     for (let i = 0; i < key.length; i++) {
//         hash = key.charCodeAt(i) + ((hash << 5) - hash);
//     }
//     const hue = Math.abs(hash) % 360;
//     const saturation = 70;
//     const lightness = 90; // adjust for lighter or darker backgrounds

//     const bg = `hsl(${hue}, ${saturation}%, ${lightness}%)`;
//     const border = `hsl(${hue}, ${saturation}%, ${Math.max(lightness - 30, 20)}%)`;

//     // Pick text color based on background lightness
//     const text = lightness > 60 ? '#000' : '#fff';

//     return { bg, border, text };
// }

const colorPalette = [
    { "bg": "#e6194B", "border": "#b20030", "textColor": "#000000" },
    { "bg": "#3cb44b", "border": "#2a7d2a", "textColor": "#000000" },
    { "bg": "#ffe119", "border": "#c7b800", "textColor": "#000000" },
    { "bg": "#4363d8", "border": "#2a3a9d", "textColor": "#FFFFFF" },
    { "bg": "#f58231", "border": "#b25020", "textColor": "#000000" },
    { "bg": "#911eb4", "border": "#600f80", "textColor": "#FFFFFF" },
    { "bg": "#42d4f4", "border": "#2aa0aa", "textColor": "#000000" },
    { "bg": "#f032e6", "border": "#b20db2", "textColor": "#000000" },
    { "bg": "#bfef45", "border": "#8cc732", "textColor": "#000000" },
    { "bg": "#fabed4", "border": "#e07a9a", "textColor": "#000000" },
    { "bg": "#469990", "border": "#2e6660", "textColor": "#000000" },
    { "bg": "#dcbeff", "border": "#aa99cc", "textColor": "#000000" },
    { "bg": "#9A6324", "border": "#6d4318", "textColor": "#FFFFFF" },
    { "bg": "#fffac8", "border": "#e6d99a", "textColor": "#000000" },
    { "bg": "#800000", "border": "#550000", "textColor": "#FFFFFF" },
    { "bg": "#aaffc3", "border": "#66cc99", "textColor": "#000000" },
    { "bg": "#808000", "border": "#505000", "textColor": "#000000" },
    { "bg": "#ffd8b1", "border": "#e6a87c", "textColor": "#000000" },
    { "bg": "#000075", "border": "#000050", "textColor": "#FFFFFF" },
    { "bg": "#a9a9a9", "border": "#707070", "textColor": "#000000" },
    { "bg": "#8bea93", "border": "#35db42", "textColor": "#000000" },
    { "bg": "#614fe5", "border": "#2c19b5", "textColor": "#FFFFFF" },
    { "bg": "#d1a852", "border": "#957227", "textColor": "#000000" },
    { "bg": "#cfe95c", "border": "#a6c51a", "textColor": "#000000" },
    { "bg": "#d24ca9", "border": "#942471", "textColor": "#000000" },
    { "bg": "#57cce0", "border": "#209cb1", "textColor": "#000000" },
    { "bg": "#e1d48a", "border": "#ccb739", "textColor": "#000000" },
    { "bg": "#98d6e6", "border": "#46b5d2", "textColor": "#000000" },
    { "bg": "#c871f7", "border": "#a310f3", "textColor": "#000000" },
    { "bg": "#1da1e1", "border": "#116087", "textColor": "#000000" },
    { "bg": "#e968b5", "border": "#ce1d87", "textColor": "#000000" },
    { "bg": "#bd4bd1", "border": "#812592", "textColor": "#000000" },
    { "bg": "#b750d9", "border": "#8122a0", "textColor": "#000000" },
    { "bg": "#e53178", "border": "#9d1349", "textColor": "#000000" },
    { "bg": "#6789f2", "border": "#1244e1", "textColor": "#000000" },
    { "bg": "#7bdb68", "border": "#41b32a", "textColor": "#000000" },
    { "bg": "#2d3aee", "border": "#0d17a9", "textColor": "#FFFFFF" },
    { "bg": "#72fba0", "border": "#0ff85c", "textColor": "#000000" },
    { "bg": "#e496d6", "border": "#d044b6", "textColor": "#000000" },
    { "bg": "#d87e60", "border": "#a94829", "textColor": "#000000" }
]


let assignedColors = {};
let currentColorIndex = 0;

const resetColorVariables = () => {
    assignedColors = {};
    currentColorIndex = 0;
}

const getColorFromIds = (subject_id, topic_id) => {
    const key = `${subject_id}-${topic_id}`;

    if (assignedColors[key]) {
        return assignedColors[key];
    }

    // Assign next color in round-robin
    const index = currentColorIndex % colorPalette.length;
    currentColorIndex++;

    const color = { ...colorPalette[index], text: '#000' };
    assignedColors[key] = color;

    return color;
}
const AssignmentMatrix = (props) => {

    const helpTextRef = useRef(new HelpText());
    const helpText = helpTextRef.current;

    const [selectedSemester, setSelectedSemester] = useState(null);
    const [isOldSemester, setIsOldSemester] = useState(false);

    const [shouldLoadAssignment, setShouldLoadAssignment] = useState(true);
    const [loading, setLoading] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [showCategoryModal, setShowCategoryModal] = useState(false);
    const [showAssignmentDetailModal, setShowAssignmentDetailModal] = useState(false);
    const [searchText, setSearchText] = useState("");

    const [columnOrder, setColumnOrder] = useState([...Array(DEFAULT_ASSIGNMENT_COUNT).keys()]);
    const [draggedColIndex, setDraggedColIndex] = useState(null);

    const [courses, setCourses] = useState(null);
    const [selectedCourse, setSelectedCourse] = useState(null);
    const [subjects, setSubjects] = useState(null);
    const [topics, setTopics] = useState(null);
    const [categories, setCategories] = useState(null);
    const [selectedCategories, setSelectedCategories] = useState(null);
    const [matrixCategories, setMatrixCategories] = useState([]);
    const [assignments, setAssignments] = useState([]);

    // course matrix categories
    const [courseMatrixCategories, setCourseMatrixCategories] = useState([]);

    const [allAssignmentDetails, setAllAssignmentDetails] = useState([]);
    const [assignmentDetails, setAssignmentDetails] = useState([]);
    const [selectedAssignment, setSelectedAssignment] = useState(null);

    const [showNewAssignmentModal, setShowNewAssignmentModal] = useState(false);

    // This is when a category cell is clicked
    const [pickedAssignment, setPickedAssignment] = useState(null);
    const [pickedCategory, setPickedCategory] = useState(null);

    const [selectedSubject, setSelectedSubject] = useState(null);
    const [selectedTopic, setSelectedTopic] = useState(null);

    const [showArrow, setShowArrow] = useState(false);

    // Right click cell
    const [rightClickedCategory, setRightClickedCategory] = useState(null);
    const [sourceCategory, setSourceCategory] = useState(null);
    const [targetCategory, setTargetCategory] = useState(null);
    const [contextMenuAnchorEl, setContextMenuAnchorEl] = useState(null);
    const popoverAnimFrameRef = useRef(null);
    const [action, setAction] = useState(null);

    // Import assign
    const [showImportModal, setShowImportModal] = useState(false);

    const [showViewRawData, setShowViewRawData] = useState(false);
    const [showDeleteAssignment, setShowDeleteAssignment] = useState(false);
    const [showCopyQuiz, setShowCopyQuiz] = useState(false);

    // ui
    const [matrixSize, setMatrixSize] = useState("medium");

    const [sections, setSections] = useState([]);
    const [selectedSection, setSelectedSection] = useState(null);
    const [selectedSectionName, setSelectedSectionName] = useState("");

    const [hasSubSections, setHasSubSections] = useState(false);
    const [subsections, setSubsections] = useState([]);
    const [selectedSubsection, setSelectedSubsection] = useState(null);

    // delete category
    const [showDeleteCategory, setShowDeleteCategory] = useState(false);
    // ui
    const [compact, setCompact] = useState(false);

    /*  useEffect(() => {
        const handleContextmenu = e => {
            e.preventDefault()
         }
         document.addEventListener('contextmenu', handleContextmenu)
         return function cleanup() {
             document.removeEventListener('contextmenu', handleContextmenu)
         }
     }, []) */

    const clearAllNotifications = () => {
        NotificationManager.listNotify.forEach(n => {
            if (n && n.id) {
                NotificationManager.remove({ id: n?.id })
            }
        });
    }

    const mappedCategories = useMemo(() => {
        return categories?.map(category => ({
            id: category.category_id,
            label: category.category_name,
            data: category,
        })) || [];
    }, [categories]);

    const checkScroll = () => {
        const table = document.querySelector(".assignment-table");
        if (table) {
            let val = table.scrollWidth > table.clientWidth
            setShowArrow(val);
        }
    };


    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                setRightClickedCategory(null);
                setTargetCategory(null);
                setContextMenuAnchorEl(null);
                setSourceCategory(null);
                setAction(null);
            }
        };

        window.addEventListener('keydown', handleKeyDown);

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, []);

    useEffect(() => {
        checkScroll();

        // Optional: also check on window resize
        window.addEventListener("resize", checkScroll);
        return () => window.removeEventListener("resize", checkScroll);
    }, [assignmentDetails]);

    useEffect(() => {
        // getCourses();
        getSubjects();
    }, []);


    useEffect(() => {
        if (assignmentDetails && assignmentDetails.length) {
            // Get all the unique categories by the order of assignmentDetails
            let updatedMatrixCategories = [...matrixCategories];
            // assignmentDetails.reverse();
            let catKeysSet = new Set();

            updatedMatrixCategories.forEach(matrixCat => {
                let catKey = `${matrixCat.subject_id}_${matrixCat.topic_id}_${matrixCat.category_id}`;
                if (!catKeysSet.has(catKey)) {
                    catKeysSet.add(catKey);
                }
            })

            assignmentDetails.forEach(assignDetail => {
                if (assignDetail.quiz_subcat_info) {
                    assignDetail.quiz_subcat_info.forEach(detail => {
                        let catKey = `${detail.subject_id}_${detail.topic_id}_${detail.category_id}`;
                        if (!catKeysSet.has(catKey)) {
                            catKeysSet.add(catKey);
                            updatedMatrixCategories.push({
                                quiz_id: assignDetail.quiz_id,
                                quiz_type: assignDetail.quiz_type,
                                subject_name: detail.subject_name,
                                topic_name: detail.topic_name,
                                category_name: detail.category_Name || detail.category_name,
                                key: catKey,
                                subject_id: detail.subject_id,
                                topic_id: detail.topic_id,
                                category_id: detail.category_id,
                                subject_color: detail.subject_color,
                                subject_short : detail.subject_short_form,
                                topic_color: detail.topic_color,
                                topic_short : detail.topic_short_form,
                                columnDataArr: [],
                            })
                        }
                    })
                }
            })

            updatedMatrixCategories = updatedMatrixCategories.map(cat => {
                return { ...cat, key: `${cat.subject_id}_${cat.topic_id}_${cat.category_id}` };
            })

            updatedMatrixCategories.forEach((matrixCategory, index) => {
                let columnDataArr = [];
                assignmentDetails.forEach(assignDetail => {

                    let categoryMasteryCountJSON = {};
                    let categoryIsRequiredJSON = {};
                    let categoryPositionJSON = {};
                    let categoryNoOfQuestionsJSON = {};
                    try {
                        categoryMasteryCountJSON = JSON.parse(assignDetail.category_mastery_count || '{}');
                        categoryIsRequiredJSON = JSON.parse(assignDetail.category_is_required || '{}');
                        categoryPositionJSON = JSON.parse(assignDetail.category_position || '{}');
                        categoryNoOfQuestionsJSON = JSON.parse(assignDetail.category_number_of_questions || '{}');
                    } catch (e) {
                        console.error('JSON parse error in assignment:', assignDetail.id || assignDetail);
                    }
                    if (assignDetail.quiz_subcat_info) {
                        let category = assignDetail.quiz_subcat_info.find(cat => {
                            let key = `${cat.subject_id}_${cat.topic_id}_${cat.category_id}`;
                            if (key === matrixCategory.key) {
                                return cat;
                            }
                            return null;
                        });
                        if (category) {
                            let mc = categoryMasteryCountJSON?.[matrixCategory.key] ?? null;
                            let noOfQuestions = categoryNoOfQuestionsJSON[matrixCategory.key] ?? null;
                            columnDataArr.push({
                                quiz_id: assignDetail.quiz_id,
                                quiz_name: assignDetail.quiz_name,
                                quiz_type: assignDetail.quiz_type,
                                masteryCount: mc === 0 ? DEFAULT_MASTERY_COUNT : mc,
                                noOfQuestions: noOfQuestions && noOfQuestions !== 0 ? noOfQuestions : category.question_count,
                                atFirst: categoryPositionJSON?.[matrixCategory.key]?.category_at_begining === 1 ?? null,
                                atLast: categoryPositionJSON?.[matrixCategory.key]?.category_at_last === 1 ?? null,
                                freeChoice: categoryIsRequiredJSON?.[matrixCategory.key] === NOT_REQUIRED ?? null,
                                isTest: assignDetail.quiz_type === 1,
                                isPracticeAssignment: assignDetail.is_practice_assignment,
                            });
                        } else {
                            columnDataArr.push({
                                quiz_id: assignDetail.quiz_id,
                                quiz_type: assignDetail.quiz_type,
                            });
                        }
                    } else {
                        columnDataArr.push({
                            quiz_id: assignDetail.quiz_id,
                            quiz_type: assignDetail.quiz_type,
                        });
                    }
                })
                updatedMatrixCategories[index].columnDataArr = columnDataArr;
            })

            //console.debug("updatedMatrixCategories>>??", updatedMatrixCategories)
            /* updatedMatrixCategories.sort((catA, catB) => {
                return catA.topic_name.localeCompare(catB.topic_name);
            })
            updatedMatrixCategories.sort((catA, catB) => {
                return catA.category_name.localeCompare(catB.category_name);
            }) */
            updatedMatrixCategories.sort((catA, catB) => {
                const subjectComparsion = catA.subject_name.localeCompare(catB.subject_name);
                if (subjectComparsion !== 0) return subjectComparsion;

                // First compare by topic_name
                const topicComparison = catA.topic_name.localeCompare(catB.topic_name);
                if (topicComparison !== 0) return topicComparison;

                // If topic_name is same, compare by category_name
                return catA.category_name.localeCompare(catB.category_name);
            });

            resetColorVariables();

            setMatrixCategories(updatedMatrixCategories);

        }
    }, [assignmentDetails]);

    useEffect(() => {
        if (selectedCourse) {
            getCourseSections();
        }
    }, [selectedCourse]);

    const getCourseSections = () => {
        let payload = {
            course_id: selectedCourse.id,
            semesterID: selectedSemester.id,
        }
        ApiRequestService({
            method: 'post',
            url: '/getAllSections',
            data: payload
        }).then(async (res) => {
            if (res && res.data && res.data.data) {
                let sectionsArr = res.data.data.section_names;
                setSections(sectionsArr);
            }
        })
    }

    useEffect(() => {
        if (sections && shouldLoadAssignment) {
            if (sections && sections.length) {
                let firstSection = sections[0];
                setSelectedSection(firstSection.section_id)
                handleSectionSelect({
                    target: {
                        value: firstSection.section_id,
                    }
                })
            }
        }
    }, [sections])

    useEffect(() => {
        if (targetCategory) {
            console.debug("pasting>>??", targetCategory);
            handlePaste();
        }
    }, [targetCategory])

    const onCompleteCopyQuiz = () => {
        setShowImportModal(false);
        if (selectedCourse && selectedCourse.id && selectedSection) {
            setSelectedSubsection(null);
            getAssignments({
                course_id: selectedCourse.id,
                section_Id: selectedSection,
            })
        }
    }

    const onAfterPreviewClick = (quizID) => {
        let tempAssignmentDetails = [];
        if (assignmentDetails && assignmentDetails.length) {
            tempAssignmentDetails = [...assignmentDetails];
        }
        let index = tempAssignmentDetails.findIndex(tempAssignDetail => tempAssignDetail.quiz_id === quizID);
        if (index !== undefined && index > -1) {
            tempAssignmentDetails[index].isQuizAttended = true;
            // console.debug("tempAssignmentDetails >> 1", tempAssignmentDetails)
            setAssignmentDetails(tempAssignmentDetails);
        }
    }

    const handleDeleteUserDataForQuiz = (quizID, showSuccessNotification, shouldUpdate) => {
        if (shouldUpdate) {
            let tempAssignmentDetails = [];
            if (assignmentDetails && assignmentDetails.length) {
                tempAssignmentDetails = [...assignmentDetails];
            }
            let index = tempAssignmentDetails.findIndex(tempAssignDetail => tempAssignDetail.quiz_id === quizID);
            if (index !== undefined && index > -1) {
                tempAssignmentDetails[index].isQuizAttended = false;
                // console.debug("tempAssignmentDetails >> 2", tempAssignmentDetails)
                setAssignmentDetails(tempAssignmentDetails);
            }
        }

        ApiRequestService({
            method: 'post',
            url: '/deleteUserQuizAttendedData',
            data: {
                quiz_id: quizID
            }
        }).then(res => {
            if (res != null &&
                res.data != null &&
                res.data.message !== null &&
                res.data.message !== "") {
                NotificationManager.error('Error while deleting the user record', 'ERROR', 3000);
            } else {
                if (showSuccessNotification) {
                    NotificationManager.success("User record deleted successfully!", 'Success', 3000);
                }
                // this.setState({ isQuizAttendedByUser: false })
            }
        }).catch(error => {
            NotificationManager.error('Error while deleting the user record', 'ERROR', 3000);
            console.error('Error while Deleting the User Data ', error);
        }).finally(() => {
            // this.setState({
            //     resetAttendQuizButtonLoader: false
            // });
        });
    }

    const validateSubcategoryOrder = (subcategories) => {
        const seenCategoryKeys = [];
        const categoryKeyMap = subcategories.map(subcat =>
            `${subcat.subject_id}_${subcat.topic_id}_${subcat.category_id}`
        );

        for (let i = 0; i < categoryKeyMap.length; i++) {
            const key = categoryKeyMap[i];

            // If it's a new key, push it
            if (!seenCategoryKeys.includes(key)) {
                seenCategoryKeys.push(key);
            } else {
                // If key was seen earlier and is not the most recent, it's an interleaving
                if (seenCategoryKeys[seenCategoryKeys.length - 1] !== key) {
                    return false; // Invalid order
                }
            }
        }

        return true; // Valid order
    };

    const checkIfAssignmentIsValid = (assignmentDetail) => {
        console.debug("assignmentDetail>>??", assignmentDetail)
        if (assignmentDetail.quiz_name === "") {
            NotificationManager.error("Assignment name cannot be empty.", "Invalid Assignment")
            return false;
        }
        if (!assignmentDetail.start_date || !assignmentDetail.start_time) {
            NotificationManager.error("Please give assingnment a Start Date", "Invalid Assignment")
            return false;
        }
        if (!assignmentDetail.end_date || !assignmentDetail.end_time) {
            NotificationManager.error("Please give assingnment a End Date", "Invalid Assignment")
            return false;
        }

        if (assignmentDetail.sections_list === null || assignmentDetail.sections_list?.length === 0) {
            let msg = "Please select atleast one section"
            if (assignmentDetail.enable_subsection) {
                msg = "Please select atleast one section & subsection"
            }
            NotificationManager.error(msg, "Invalid Assignment");
            return false;
        }

        // check if atlease one subcategories is present
        if (assignmentDetail.quiz_subcat_info === null || assignmentDetail.quiz_subcat_info === undefined || assignmentDetail.quiz_subcat_info.length === 0) {
            NotificationManager.error("Atleast one subcategory should be added to the assignment", "Invalid Assignment");
            return false;
        }

        if (!validateSubcategoryOrder(assignmentDetail.quiz_subcat_info)) {
            NotificationManager.error("Please ensure that all the subcategories of a category are placed sequentially next to each other and are not spread out.", "Invalid Subcategory Order", 3000);
            return false;
        }

        if (assignmentDetail.quiz_subcat_info === null || (assignmentDetail.quiz_subcat_info && assignmentDetail.quiz_subcat_info.length === 0)) {
            NotificationManager.error("Assignment must have atleast 1 subcategory present.", "Invalid Assignment")
            return false;
        }


        return true;
    }

    const showAlert = async (title, msg, yesLabel, noLabel) => {
        return new Promise((resolve, reject) => {
            confirmAlert({
                title: title,
                // message: msg,
                childrenElement: () => <div className="custom-alert-content">{msg}</div>,
                confirmLabel: noLabel,
                cancelLabel: yesLabel,
                onConfirm: () => resolve(false),
                onCancel: () => resolve(true),
                overlayClassName: "overlay-custom-class-name",
            });
        });
    }

    const handleUpdateAssignmentDetails = (updatedAssignmentDetails) => {
        let sortedAssignments = getSortedAssignments(updatedAssignmentDetails);
        setAssignmentDetails([...sortedAssignments]);
        // NotificationManager.success("Assignments are arranged by")
    }

    useEffect(() => {
        if (assignmentDetails && selectedAssignment) {
            const newIndex = assignmentDetails.findIndex(assign => assign.quiz_id === selectedAssignment.quiz_id);
            if (newIndex === -1) return;
            setSelectedAssignment(assignmentDetails[newIndex]);
            let id = `assignment-header-${assignmentDetails[newIndex].quiz_id}`;

            requestAnimationFrame(() => {
                let ele = document.getElementById(id);
                if (!ele) return;

                const newRect = ele.getBoundingClientRect();
                const oldRect = anchorEl?.getBoundingClientRect?.();

                // If no old position or same position, just set directly
                if (!oldRect || (Math.abs(oldRect.left - newRect.left) < 1 && Math.abs(oldRect.top - newRect.top) < 1)) {
                    setAnchorEl(ele);
                    return;
                }

                // Cancel any ongoing animation
                if (popoverAnimFrameRef.current) {
                    cancelAnimationFrame(popoverAnimFrameRef.current);
                }

                const duration = 500;
                const startTime = performance.now();
                const easeOut = (t) => 1 - Math.pow(1 - t, 3);

                const animate = (now) => {
                    const elapsed = now - startTime;
                    const progress = Math.min(elapsed / duration, 1);
                    const t = easeOut(progress);

                    const currentRect = {
                        top: oldRect.top + (newRect.top - oldRect.top) * t,
                        left: oldRect.left + (newRect.left - oldRect.left) * t,
                        bottom: oldRect.bottom + (newRect.bottom - oldRect.bottom) * t,
                        right: oldRect.right + (newRect.right - oldRect.right) * t,
                        width: oldRect.width + (newRect.width - oldRect.width) * t,
                        height: oldRect.height + (newRect.height - oldRect.height) * t,
                    };

                    setAnchorEl({
                        getBoundingClientRect: () => currentRect,
                        nodeType: 1,
                    });

                    if (progress < 1) {
                        popoverAnimFrameRef.current = requestAnimationFrame(animate);
                    } else {
                        setAnchorEl(ele);
                        popoverAnimFrameRef.current = null;
                    }
                };

                popoverAnimFrameRef.current = requestAnimationFrame(animate);
            });
        }
    }, [assignmentDetails])

    const getKey = (subcat) => `${subcat.subject_id}_${subcat.topic_id}_${subcat.category_id}_${subcat.subcategory_id}`;
    const getCategoryKey = (subcat) => `${subcat.subject_id}_${subcat.topic_id}_${subcat.category_id}`;


    const handlePaste = async () => {

        let srcCategory = rightClickedCategory;

        let sourceAssignment = assignmentDetails[rightClickedCategory.columnDataIndex];
        let targetAssignment = assignmentDetails[targetCategory.columnDataIndex];
        console.debug("sourceAssignment and targetAssignment", sourceAssignment, targetAssignment);

        // Check if the source category has at_first/at_last turned ON and the target assignment has other category at first/at last on
        let targetHasAtFrist = false;
        let targetHasAtLast = false;
        console.debug("srcCategory>>??", srcCategory)
        if (srcCategory.atFirst) {
            // check if any target asign category except the target category has atfirst ON
            if (targetAssignment.category_position && targetAssignment.category_position != "{}") {
                let categoryPositionMap = JSON.parse(targetAssignment.category_position);
                Object.entries(categoryPositionMap).forEach(([key, val]) => {
                    console.debug("key, val >>", key, val);
                    if (key !== srcCategory.key) {
                        if (val.category_at_begining) {
                            targetHasAtFrist = true;
                        }
                    }
                });
            }
        }

        if (srcCategory.atLast) {
            // check if any target asign category except the target category has atfirst ON
            if (targetAssignment.category_position && targetAssignment.category_position != "{}") {
                let categoryPositionMap = JSON.parse(targetAssignment.category_position);
                Object.entries(categoryPositionMap).forEach(([key, val]) => {
                    console.debug("key, val >>", key, val);
                    if (key !== srcCategory.key) {
                        if (val.category_at_last) {
                            targetHasAtLast = true;
                        }
                    }
                });
            }
        }

        // When pasting check if is targetAssignment has existing value, if so show an alert
        let present = targetAssignment?.quiz_details?.find(quiz_detail => {
            let key = `${quiz_detail.subject_id}_${quiz_detail.topic_id}_${quiz_detail.category_id}`
            return key === srcCategory.key;
        });

        let showAlertDialog = false;
        let alertTitle = "";
        let alertMessage = "";
        if (present && targetHasAtFrist) {
            showAlertDialog = true;
            alertTitle = "Replace Existing Data";
            alertMessage = <div>
                <div>This cell already contains a category. Do you want to overwrite it with the copied one?</div>
                <br />
                <div>Note: Another category in this assignment has "At First" turned ON, so "At First" will be turned OFF for the copied category.</div>
            </div>
        } else if (present && targetHasAtLast) {
            showAlertDialog = true;
            alertTitle = "Replace Existing Data";
            alertMessage = <div>
                <div>This cell already contains a category. Do you want to overwrite it with the copied one?</div>
                <br />
                <div>Note: Another category in this assignment has "At Last" turned ON, so "At Last" will be turned OFF for the copied category.</div>
            </div>
        } else if (present) {
            showAlertDialog = true;
            alertTitle = "Replace Existing Data";
            alertMessage = <div>
                <div>This cell already contains a category. Do you want to overwrite it with the copied one?</div>
            </div>
        } else if (targetHasAtFrist) {
            showAlertDialog = true;
            alertTitle = "At First Conflict Detected";
            alertMessage = <div>
                <div>Note: Another category in this assignment has "At First" turned ON, so "At First" will be turned OFF for the copied category.</div>
            </div>
        } else if (targetHasAtLast) {
            showAlertDialog = true;
            alertTitle = "At Last Conflict Detected";
            alertMessage = <div>
                <div>Note: Another category in this assignment has "At Last" turned ON, so "At Last" will be turned OFF for the copied category.</div>
            </div>
        }

        if (showAlertDialog) {
            setTargetCategory(null);
            setContextMenuAnchorEl(null);
            const result = await showAlert(alertTitle, alertMessage, "Yes", "No");
            if (result === false) {
                return;
            }
        }

        /* 
            Things needed to be updated when copying or pasting (only diff is when user cuts we have to remove it from source)
            1. category_mastery_count - DONE
            2. category_number_of_questions - DONE
            3. category_nocqc - DONE
            4. random_subcategory_order - DONE
            5. category_is_required - DONE
            6. category_position - DONE
        */

        if (action === 'copy') { // COPY and paste

            // category_mastery_count
            let srcCategoryMasteryCountObj = {};
            if (sourceAssignment.category_mastery_count !== "" && sourceAssignment.category_mastery_count !== "{}") {
                srcCategoryMasteryCountObj = JSON.parse(sourceAssignment.category_mastery_count);
            }
            let targetCategoryMasteryCountObj = {};
            if (targetAssignment.category_mastery_count !== "" && targetAssignment.category_mastery_count !== "{}") {
                targetCategoryMasteryCountObj = JSON.parse(targetAssignment.category_mastery_count);
            }
            targetCategoryMasteryCountObj[srcCategory.key] = srcCategoryMasteryCountObj[srcCategory.key]
            targetAssignment["category_mastery_count"] = JSON.stringify(targetCategoryMasteryCountObj)

            // category_number_of_questions
            let srcCategoryNumberOfQuestionsObj = {};
            if (sourceAssignment.category_number_of_questions !== "" && sourceAssignment.category_number_of_questions !== "{}") {
                srcCategoryNumberOfQuestionsObj = JSON.parse(sourceAssignment.category_number_of_questions);
            }
            let targetCategoryNumberOfQuestionsObj = {};
            if (targetAssignment.category_number_of_questions !== "" && targetAssignment.category_number_of_questions !== "{}") {
                targetCategoryNumberOfQuestionsObj = JSON.parse(targetAssignment.category_number_of_questions);
            }
            targetCategoryNumberOfQuestionsObj[srcCategory.key] = srcCategoryNumberOfQuestionsObj[srcCategory.key]
            targetAssignment["category_number_of_questions"] = JSON.stringify(targetCategoryNumberOfQuestionsObj)

            // category_nocqc
            let srcCategoryNocqcObj = {};
            if (sourceAssignment.category_nocqc !== "" && sourceAssignment.category_nocqc !== "{}") {
                srcCategoryNocqcObj = JSON.parse(sourceAssignment.category_nocqc);
            }
            let targetCategoryNocqcObj = {};
            if (targetAssignment.category_nocqc !== "" && targetAssignment.category_nocqc !== "{}") {
                targetCategoryNocqcObj = JSON.parse(targetAssignment.category_nocqc);
            }
            targetCategoryNocqcObj[srcCategory.key] = srcCategoryNocqcObj[srcCategory.key]
            targetAssignment["category_nocqc"] = JSON.stringify(targetCategoryNocqcObj)

            // random_subcategory_order
            let srcRandomSubcategoryOrderObj = {};
            if (sourceAssignment.category_is_required !== "" && sourceAssignment.category_is_required !== "{}") {
                srcRandomSubcategoryOrderObj = JSON.parse(sourceAssignment.category_is_required);
            }
            let targetRandomSubcategoryOrderObj = {};
            if (targetAssignment.random_subcategory_order !== "" && targetAssignment.random_subcategory_order !== "{}") {
                targetRandomSubcategoryOrderObj = JSON.parse(targetAssignment.random_subcategory_order);
            }
            targetRandomSubcategoryOrderObj[srcCategory.key] = srcRandomSubcategoryOrderObj[srcCategory.key]
            targetAssignment["random_subcategory_order"] = JSON.stringify(targetRandomSubcategoryOrderObj)

            // category_is_required
            let srcCategoryIsRequiredObj = {};
            if (sourceAssignment.category_is_required !== "" && sourceAssignment.category_is_required !== "{}") {
                srcCategoryIsRequiredObj = JSON.parse(sourceAssignment.category_is_required);
            }
            let targetCategoryIsRequiredObj = {};
            if (targetAssignment.category_is_required !== "" && targetAssignment.category_is_required !== "{}") {
                targetCategoryIsRequiredObj = JSON.parse(targetAssignment.category_is_required);
            }
            targetCategoryIsRequiredObj[srcCategory.key] = srcCategoryIsRequiredObj[srcCategory.key]
            targetAssignment["category_is_required"] = JSON.stringify(targetCategoryIsRequiredObj)

            // category_position
            let srcCategoryPositionObj = {};
            if (sourceAssignment.category_position !== "" && sourceAssignment.category_position !== "{}") {
                srcCategoryPositionObj = JSON.parse(sourceAssignment.category_position);
            }
            let targetCategoryPositionObj = {};
            if (targetAssignment.category_position !== "" && targetAssignment.category_position !== "{}") {
                targetCategoryPositionObj = JSON.parse(targetAssignment.category_position);
            }
            targetCategoryPositionObj[srcCategory.key] = srcCategoryPositionObj[srcCategory.key];
            if (targetHasAtFrist) {
                targetCategoryPositionObj[srcCategory.key].category_at_begining = 0;
            }
            if (targetHasAtLast) {
                targetCategoryPositionObj[srcCategory.key].category_at_last = 0;
            }
            targetAssignment["category_position"] = JSON.stringify(targetCategoryPositionObj)

            // get the subcategories that needs to be deleted
            let delete_arr = [];
            if (present) {
                const sourceKeys = sourceAssignment.quiz_subcat_info
                    .filter(qs => getCategoryKey(qs) === srcCategory.key)
                    .map(qs => getKey(qs));

                targetAssignment.quiz_subcat_info.forEach(qs => {
                    if (getCategoryKey(qs) === srcCategory.key) {
                        let key = getKey(qs);
                        if (!sourceKeys.includes(key)) {
                            delete_arr.push(qs);
                        }
                    }
                });
            }
            targetAssignment.quiz_delete_arr = delete_arr;

            // quiz_subcat_info
            let categoryKey = srcCategory.key;
            let srcSubCatInfoArr = sourceAssignment.quiz_subcat_info.filter(subcatInfo => {
                let key = `${subcatInfo.subject_id}_${subcatInfo.topic_id}_${subcatInfo.category_id}`
                return key === categoryKey;
            });

            let currentMaxOrder = 0;
            if (Array.isArray(targetAssignment.quiz_subcat_info) && targetAssignment.quiz_subcat_info.length > 0) {
                currentMaxOrder = Math.max(
                    ...targetAssignment.quiz_subcat_info.map(subcatInfo => subcatInfo.order || 0)
                );
            } else {
                targetAssignment.quiz_subcat_info = [];
            }

            targetAssignment.quiz_subcat_info = targetAssignment.quiz_subcat_info.filter(subcatInfo => {
                let key = `${subcatInfo.subject_id}_${subcatInfo.topic_id}_${subcatInfo.category_id}`;
                return key !== categoryKey;
            });
            let updatedSubCatInfoArr = srcSubCatInfoArr.map((info, index) => ({
                ...info,
                order: currentMaxOrder + index + 1
            }));
            targetAssignment.quiz_subcat_info.push(...updatedSubCatInfoArr);

            /* if (targetAssignment.quiz_subcat_info === null) {
                targetAssignment.quiz_subcat_info = [...srcSubCatInfoArr];
            } else {
                targetAssignment.quiz_subcat_info = targetAssignment.quiz_subcat_info.filter(subcatInfo => {
                    let key = `${subcatInfo.subject_id}_${subcatInfo.topic_id}_${subcatInfo.category_id}`;
                    return key !== categoryKey;
                });
                targetAssignment.quiz_subcat_info.push(...srcSubCatInfoArr);
            } */

            // quiz_details
            let srcQuizDetailsArr = sourceAssignment.quiz_details.filter(quizDetailInfo => {
                let key = `${quizDetailInfo.subject_id}_${quizDetailInfo.topic_id}_${quizDetailInfo.category_id}`
                return key === categoryKey;
            });
            currentMaxOrder = 0;
            if (Array.isArray(targetAssignment.quiz_details) && targetAssignment.quiz_details.length > 0) {
                currentMaxOrder = Math.max(
                    ...targetAssignment.quiz_details.map(detail => detail.order || 0)
                );
            } else {
                targetAssignment.quiz_details = [];
            }
            targetAssignment.quiz_details = targetAssignment.quiz_details.filter(quizDetailInfo => {
                let key = `${quizDetailInfo.subject_id}_${quizDetailInfo.topic_id}_${quizDetailInfo.category_id}`;
                return key !== categoryKey;
            });
            let updatedQuizDetailsArr = srcQuizDetailsArr.map((info, index) => ({
                ...info,
                order: currentMaxOrder + index + 1
            }));
            targetAssignment.quiz_details.push(...updatedQuizDetailsArr);
            /* if (targetAssignment.quiz_details === null) {
                targetAssignment.quiz_details = [...srcQuizDetailsArr];
            } else {
                targetAssignment.quiz_details = targetAssignment.quiz_details.filter(quizDetailInfo => {
                    let key = `${quizDetailInfo.subject_id}_${quizDetailInfo.topic_id}_${quizDetailInfo.category_id}`;
                    return key !== categoryKey;
                });
                targetAssignment.quiz_details.push(...srcQuizDetailsArr);
            } */


            let updatedSubcategories = [];

            const atFirstKeys = new Set();
            const atLastKeys = new Set();

            Object.entries(JSON.parse(targetAssignment.category_position)).forEach(([key, value]) => {
                if (value.category_at_begining) {
                    atFirstKeys.add(key);
                } else if (value.category_at_last) {
                    atLastKeys.add(key);
                }
            })

            let middleSubcats = [];
            let lastSubcats = [];
            let order = 1;

            targetAssignment.quiz_subcat_info.forEach(subcat => {
                const key = `${subcat.subject_id}_${subcat.topic_id}_${subcat.category_id}`;

                if (atFirstKeys.has(key)) {
                    updatedSubcategories.push({
                        ...subcat,
                        order: order++,
                    });
                } else if (atLastKeys.has(key)) {
                    lastSubcats.push(subcat);
                } else {
                    middleSubcats.push(subcat);
                }
            });

            middleSubcats.forEach(subcat => {
                updatedSubcategories.push({
                    ...subcat,
                    order: order++,
                });
            });

            lastSubcats.forEach(subcat => {
                updatedSubcategories.push({
                    ...subcat,
                    order: order++,
                });
            });

            targetAssignment.quiz_details = [...updatedSubcategories];
            targetAssignment.quiz_subcat_info = [...updatedSubcategories];

            console.debug("targetAssignment>>??", targetAssignment);
            // return;

            setLoading(true);
            handleSaveAssignment(targetAssignment).then(result => {
                //console.debug("result>>??", result);
                setLoading(false);
                if (result.success) {
                    NotificationManager.success("Successfully copied the category");
                    let updatedAssignmentDetails = [...assignmentDetails];
                    updatedAssignmentDetails[targetCategory.columnDataIndex] = {
                        ...targetAssignment,
                        isQuizAttended: false,
                    };
                    handleUpdateAssignmentDetails(updatedAssignmentDetails);
                } else {
                    NotificationManager.error(result.error, 4000);
                }
            });

        } else { // CUT and paste

            // category_mastery_count
            let srcCategoryMasteryCountObj = {};
            if (sourceAssignment.category_mastery_count !== "" && sourceAssignment.category_mastery_count !== "{}") {
                srcCategoryMasteryCountObj = JSON.parse(sourceAssignment.category_mastery_count);
            }
            let targetCategoryMasteryCountObj = {};
            if (targetAssignment.category_mastery_count !== "" && targetAssignment.category_mastery_count !== "{}") {
                targetCategoryMasteryCountObj = JSON.parse(targetAssignment.category_mastery_count);
            }
            targetCategoryMasteryCountObj[srcCategory.key] = srcCategoryMasteryCountObj[srcCategory.key]
            targetAssignment["category_mastery_count"] = JSON.stringify(targetCategoryMasteryCountObj)

            // category_number_of_questions
            let srcCategoryNumberOfQuestionsObj = {};
            if (sourceAssignment.category_number_of_questions !== "" && sourceAssignment.category_number_of_questions !== "{}") {
                srcCategoryNumberOfQuestionsObj = JSON.parse(sourceAssignment.category_number_of_questions);
            }
            let targetCategoryNumberOfQuestionsObj = {};
            if (targetAssignment.category_number_of_questions !== "" && targetAssignment.category_number_of_questions !== "{}") {
                targetCategoryNumberOfQuestionsObj = JSON.parse(targetAssignment.category_number_of_questions);
            }
            targetCategoryNumberOfQuestionsObj[srcCategory.key] = srcCategoryNumberOfQuestionsObj[srcCategory.key]
            targetAssignment["category_number_of_questions"] = JSON.stringify(targetCategoryNumberOfQuestionsObj)

            // category_nocqc
            let srcCategoryNocqcObj = {};
            if (sourceAssignment.category_nocqc !== "" && sourceAssignment.category_nocqc !== "{}") {
                srcCategoryNocqcObj = JSON.parse(sourceAssignment.category_nocqc);
            }
            let targetCategoryNocqcObj = {};
            if (targetAssignment.category_nocqc !== "" && targetAssignment.category_nocqc !== "{}") {
                targetCategoryNocqcObj = JSON.parse(targetAssignment.category_nocqc);
            }
            targetCategoryNocqcObj[srcCategory.key] = srcCategoryNocqcObj[srcCategory.key]
            targetAssignment["category_nocqc"] = JSON.stringify(targetCategoryNocqcObj)

            // random_subcategory_order
            let srcRandomSubcategoryOrderObj = {};
            if (sourceAssignment.category_is_required !== "" && sourceAssignment.category_is_required !== "{}") {
                srcRandomSubcategoryOrderObj = JSON.parse(sourceAssignment.category_is_required);
            }
            let targetRandomSubcategoryOrderObj = {};
            if (targetAssignment.random_subcategory_order !== "" && targetAssignment.random_subcategory_order !== "{}") {
                targetRandomSubcategoryOrderObj = JSON.parse(targetAssignment.random_subcategory_order);
            }
            targetRandomSubcategoryOrderObj[srcCategory.key] = srcRandomSubcategoryOrderObj[srcCategory.key]
            targetAssignment["random_subcategory_order"] = JSON.stringify(targetRandomSubcategoryOrderObj)

            // category_is_required
            let srcCategoryIsRequiredObj = {};
            if (sourceAssignment.category_is_required !== "" && sourceAssignment.category_is_required !== "{}") {
                srcCategoryIsRequiredObj = JSON.parse(sourceAssignment.category_is_required);
            }
            let targetCategoryIsRequiredObj = {};
            if (targetAssignment.category_is_required !== "" && targetAssignment.category_is_required !== "{}") {
                targetCategoryIsRequiredObj = JSON.parse(targetAssignment.category_is_required);
            }
            targetCategoryIsRequiredObj[srcCategory.key] = srcCategoryIsRequiredObj[srcCategory.key]
            targetAssignment["category_is_required"] = JSON.stringify(targetCategoryIsRequiredObj)

            // category_position
            let srcCategoryPositionObj = {};
            if (sourceAssignment.category_position !== "" && sourceAssignment.category_position !== "{}") {
                srcCategoryPositionObj = JSON.parse(sourceAssignment.category_position);
            }
            let targetCategoryPositionObj = {};
            if (targetAssignment.category_position !== "" && targetAssignment.category_position !== "{}") {
                targetCategoryPositionObj = JSON.parse(targetAssignment.category_position);
            }
            targetCategoryPositionObj[srcCategory.key] = srcCategoryPositionObj[srcCategory.key];
            if (targetHasAtFrist) {
                targetCategoryPositionObj[srcCategory.key].category_at_begining = 0;
            }
            if (targetHasAtLast) {
                targetCategoryPositionObj[srcCategory.key].category_at_last = 0;
            }
            targetAssignment["category_position"] = JSON.stringify(targetCategoryPositionObj)

            // get the subcategories that needs to be deleted
            let delete_arr = [];
            if (present) {
                const sourceKeys = sourceAssignment.quiz_subcat_info
                    .filter(qs => getCategoryKey(qs) === srcCategory.key)
                    .map(qs => getKey(qs));

                targetAssignment.quiz_subcat_info.forEach(qs => {
                    if (getCategoryKey(qs) === srcCategory.key) {
                        let key = getKey(qs);
                        if (!sourceKeys.includes(key)) {
                            delete_arr.push(qs);
                        }
                    }
                });
            }
            targetAssignment.quiz_delete_arr = delete_arr;

            // quiz_subcat_info
            let categoryKey = srcCategory.key;
            let srcSubCatInfoArr = sourceAssignment.quiz_subcat_info.filter(subcatInfo => {
                let key = `${subcatInfo.subject_id}_${subcatInfo.topic_id}_${subcatInfo.category_id}`
                return key === categoryKey;
            });

            let currentMaxOrder = 0;
            if (Array.isArray(targetAssignment.quiz_subcat_info) && targetAssignment.quiz_subcat_info.length > 0) {
                currentMaxOrder = Math.max(
                    ...targetAssignment.quiz_subcat_info.map(subcatInfo => subcatInfo.order || 0)
                );
            } else {
                targetAssignment.quiz_subcat_info = [];
            }

            targetAssignment.quiz_subcat_info = targetAssignment.quiz_subcat_info.filter(subcatInfo => {
                let key = `${subcatInfo.subject_id}_${subcatInfo.topic_id}_${subcatInfo.category_id}`;
                return key !== categoryKey;
            });
            let updatedSubCatInfoArr = srcSubCatInfoArr.map((info, index) => ({
                ...info,
                order: currentMaxOrder + index + 1
            }));
            targetAssignment.quiz_subcat_info.push(...updatedSubCatInfoArr);

            /* if (targetAssignment.quiz_subcat_info === null) {
                targetAssignment.quiz_subcat_info = [...srcSubCatInfoArr];
            } else {
                targetAssignment.quiz_subcat_info = targetAssignment.quiz_subcat_info.filter(subcatInfo => {
                    let key = `${subcatInfo.subject_id}_${subcatInfo.topic_id}_${subcatInfo.category_id}`;
                    return key !== categoryKey;
                });
                targetAssignment.quiz_subcat_info.push(...srcSubCatInfoArr);
            } */

            // quiz_details
            let srcQuizDetailsArr = sourceAssignment.quiz_details.filter(quizDetailInfo => {
                let key = `${quizDetailInfo.subject_id}_${quizDetailInfo.topic_id}_${quizDetailInfo.category_id}`
                return key === categoryKey;
            });
            currentMaxOrder = 0;
            if (Array.isArray(targetAssignment.quiz_details) && targetAssignment.quiz_details.length > 0) {
                currentMaxOrder = Math.max(
                    ...targetAssignment.quiz_details.map(detail => detail.order || 0)
                );
            } else {
                targetAssignment.quiz_details = [];
            }
            targetAssignment.quiz_details = targetAssignment.quiz_details.filter(quizDetailInfo => {
                let key = `${quizDetailInfo.subject_id}_${quizDetailInfo.topic_id}_${quizDetailInfo.category_id}`;
                return key !== categoryKey;
            });
            let updatedQuizDetailsArr = srcQuizDetailsArr.map((info, index) => ({
                ...info,
                order: currentMaxOrder + index + 1
            }));
            targetAssignment.quiz_details.push(...updatedQuizDetailsArr);
            /* if (targetAssignment.quiz_details === null) {
                targetAssignment.quiz_details = [...srcQuizDetailsArr];
            } else {
                targetAssignment.quiz_details = targetAssignment.quiz_details.filter(quizDetailInfo => {
                    let key = `${quizDetailInfo.subject_id}_${quizDetailInfo.topic_id}_${quizDetailInfo.category_id}`;
                    return key !== categoryKey;
                });
                targetAssignment.quiz_details.push(...srcQuizDetailsArr);
            } */


            let updatedSubcategories = [];

            const atFirstKeys = new Set();
            const atLastKeys = new Set();

            Object.entries(JSON.parse(targetAssignment.category_position)).forEach(([key, value]) => {
                if (value.category_at_begining) {
                    atFirstKeys.add(key);
                } else if (value.category_at_last) {
                    atLastKeys.add(key);
                }
            })

            let middleSubcats = [];
            let lastSubcats = [];
            let order = 1;

            targetAssignment.quiz_subcat_info.forEach(subcat => {
                const key = `${subcat.subject_id}_${subcat.topic_id}_${subcat.category_id}`;

                if (atFirstKeys.has(key)) {
                    updatedSubcategories.push({
                        ...subcat,
                        order: order++,
                    });
                } else if (atLastKeys.has(key)) {
                    lastSubcats.push(subcat);
                } else {
                    middleSubcats.push(subcat);
                }
            });

            middleSubcats.forEach(subcat => {
                updatedSubcategories.push({
                    ...subcat,
                    order: order++,
                });
            });

            lastSubcats.forEach(subcat => {
                updatedSubcategories.push({
                    ...subcat,
                    order: order++,
                });
            });

            targetAssignment.quiz_details = [...updatedSubcategories];
            targetAssignment.quiz_subcat_info = [...updatedSubcategories];

            // Now update source assignment detail since we are doing cut paste 
            delete srcCategoryMasteryCountObj[srcCategory.key];
            delete srcCategoryNumberOfQuestionsObj[srcCategory.key];
            delete srcCategoryNocqcObj[srcCategory.key];
            delete srcRandomSubcategoryOrderObj[srcCategory.key];
            delete srcCategoryIsRequiredObj[srcCategory.key];
            delete srcCategoryPositionObj[srcCategory.key];

            sourceAssignment.category_mastery_count = JSON.stringify(srcCategoryMasteryCountObj);
            sourceAssignment.category_number_of_questions = JSON.stringify(srcCategoryNumberOfQuestionsObj);
            sourceAssignment.category_nocqc = JSON.stringify(srcCategoryNocqcObj);
            sourceAssignment.random_subcategory_order = JSON.stringify(srcRandomSubcategoryOrderObj);
            sourceAssignment.category_is_required = JSON.stringify(srcCategoryIsRequiredObj);
            sourceAssignment.category_position = JSON.stringify(srcCategoryPositionObj);

            // remove the srcategory key from quiz_details and quiz_subcat_info
            let src_delete_arr = [];
            sourceAssignment.quiz_details.forEach(qd => {
                let qdKey = getCategoryKey(qd);
                if (qdKey === srcCategory.key) {
                    src_delete_arr.push(qd);
                }
            })
            sourceAssignment.quiz_delete_arr = src_delete_arr;
            sourceAssignment.quiz_details = sourceAssignment.quiz_details.filter(qd => {
                let qdKey = getCategoryKey(qd);
                return qdKey !== srcCategory.key;
            })
            sourceAssignment.quiz_subcat_info = sourceAssignment.quiz_subcat_info.filter(qsi => {
                let qsiKey = getCategoryKey(qsi);
                return qsiKey !== srcCategory.key;
            })

            let updatedSourceSubcategories = [];

            const sourceAtFirstKeys = new Set();
            const sourceAtLastKeys = new Set();

            Object.entries(JSON.parse(sourceAssignment.category_position)).forEach(([key, value]) => {
                if (value.category_at_begining) {
                    sourceAtFirstKeys.add(key);
                } else if (value.category_at_last) {
                    sourceAtLastKeys.add(key);
                }
            })

            let sourceMiddleSubcats = [];
            let sourceLastSubcats = [];
            let sourceOrder = 1;

            sourceAssignment.quiz_subcat_info.forEach(subcat => {
                const key = `${subcat.subject_id}_${subcat.topic_id}_${subcat.category_id}`;

                if (sourceAtFirstKeys.has(key)) {
                    updatedSourceSubcategories.push({
                        ...subcat,
                        order: sourceOrder++,
                    });
                } else if (sourceAtLastKeys.has(key)) {
                    sourceLastSubcats.push(subcat);
                } else {
                    sourceMiddleSubcats.push(subcat);
                }
            });

            sourceMiddleSubcats.forEach(subcat => {
                updatedSourceSubcategories.push({
                    ...subcat,
                    order: sourceOrder++,
                });
            });

            sourceLastSubcats.forEach(subcat => {
                updatedSourceSubcategories.push({
                    ...subcat,
                    order: sourceOrder++,
                });
            });

            sourceAssignment.quiz_details = [...updatedSourceSubcategories];
            sourceAssignment.quiz_subcat_info = [...updatedSourceSubcategories];

            console.debug("sourceAssignment and targetAssignment>>??", sourceAssignment, targetAssignment);
            // return;

            setLoading(true);
            Promise.all([
                handleSaveAssignment(sourceAssignment),
                handleSaveAssignment(targetAssignment)
            ]).then(([srcResult, tgtResult]) => {
                setLoading(false);

                if (srcResult.success && tgtResult.success) {
                    NotificationManager.success("Successfully moved the category");
                    let updatedAssignmentDetails = [...assignmentDetails];
                    updatedAssignmentDetails[rightClickedCategory.columnDataIndex] = {
                        ...sourceAssignment,
                        isQuizAttended: false
                    };
                    updatedAssignmentDetails[targetCategory.columnDataIndex] = {
                        ...targetAssignment,
                        isQuizAttended: false,
                    };
                    handleUpdateAssignmentDetails(updatedAssignmentDetails);
                } else {
                    NotificationManager.error("Failed to move category data", 4000);
                }
            });
        }

        setRightClickedCategory(null);
        setSourceCategory(null);
        setTargetCategory(null);
        setContextMenuAnchorEl(null);
        setAction(null);
    }

    const handleActionClick = async (currentAction) => {
        console.debug("currentAction>>??", currentAction)
        if (currentAction === "delete") {
            setShowDeleteCategory(true);
            return;
        }

        if (currentAction === 'paste') {
            handlePaste();
        } else {
            if (currentAction === "copy") {
                NotificationManager.info("Now click any another empty cell in the row to copy it.", "Category copied to your clipboard!", 5000);
            } else if (currentAction === "cut") {
                NotificationManager.info("Now click any another empty cell in the row to move it.", "Category selected to your clipboard!", 5000);
            }
            setAction(currentAction);
            setSourceCategory(rightClickedCategory);
            setContextMenuAnchorEl(null);
            setShowDeleteCategory(false);
        }
    }

    const handleSaveAssignment = (assignmentData) => {
        return new Promise((resolve, reject) => {
            let payload = {
                ...assignmentData,
                allow_practice: assignmentData.quiz_type === 0, //all quizzes are practicable
            };

            ApiRequestService({
                method: 'post',
                url: '/addQuiz',
                data: payload
            }).then(res => {
                if (res && res.data && res.data.data) {
                    resolve({ success: true, data: res.data.data });
                } else {
                    resolve({ success: true, error: "Something went wrong" });
                }
            }).catch((err) => {
                reject({ success: false, error: err });
            }).finally(() => {
                handleDeleteUserDataForQuiz(payload.quiz_id, false, false);
            });
        })
    }

    const handleLeftArrowClick = () => {
        let table = document.querySelector(".assignment-table");
        if (table) {
            table.scrollBy({
                left: -SCROLL_AMOUNT,
                behavior: "smooth",
            })
        }
    }

    const handleRightArrowClick = () => {
        let table = document.querySelector(".assignment-table");
        if (table) {
            table.scrollBy({
                left: SCROLL_AMOUNT,
                behavior: "smooth",
            })
        }
    }

    const getCourses = (semesterID) => {
        resetColorVariables();
        ApiRequestService({
            method: 'post',
            url: '/getAllCourses',
            data: {
                id: semesterID
            }
        }).then(res => {
            if (res && res.data && res.data.data) {
                let tempCourseArr = res.data.data.course_names;
                setCourses(tempCourseArr?.map(course => {
                    return {
                        ...course,
                        title: course.course_name,
                        value: course.course_id,
                        isLTICourse: course.is_lti_enabled,
                    }
                }));
                if (tempCourseArr && tempCourseArr.length) {
                    let firstCourse = tempCourseArr[0];
                    if (firstCourse) {
                        setSelectedCourse({
                            id: firstCourse.course_id,
                            label: firstCourse.course_name,
                            data: firstCourse,
                            is_lti_enabled: firstCourse.is_lti_enabled,
                        })
                    }
                }
                // let firstCourse = tempCourseArr[0];
                // if (firstCourse) {
                //     // setSelectedCourse({
                //     //     id: firstCourse.course_id,
                //     //     label: firstCourse.course_name,
                //     //     data: firstCourse,
                //     // });
                //     // getAssignments({
                //     //     course_id: firstCourse.course_id,
                //     // })
                // }
            }
        })
    }

    const getSubjects = () => {
        ApiRequestService({
            method: 'post',
            url: '/getAllSubjects'
        }).then(res => {
            if (res && res.data && res.data.data) {
                let subjectsArr = res.data.data.subject_names.filter(subj => subj.sync_validation);
                setSubjects(subjectsArr);
            }
        })
    }

    const getTopics = (payload) => {
        ApiRequestService({
            method: 'post',
            url: '/getAllTopics',
            data: payload
        }).then(res => {
            if (res && res.data && res.data.data) {
                setTopics(res.data.data.topic_names);
            }
        })
    }

    const getCategories = (payload) => {
        ApiRequestService({
            method: 'post',
            url: '/getAllCategories',
            data: payload
        }).then(res => {
            if (res && res.data && res.data.data) {
                setCategories(res.data.data.category_names);
            }
        })
    }

    const getAssignments = async (payload) => {
        console.debug("payload--->>??", payload)
        try {
            setLoading(true);
            const res = await ApiRequestService({
                method: 'post',
                url: '/getAllQuiz',
                data: payload
            });

            if (res?.data?.data?.quizes_list) {
                let quizArr = [];
                let quizIDArr = [];
                res.data.data.quizes_list.forEach(quiz => {
                    if (!quizIDArr.includes(quiz.quiz_id)) {
                        quizIDArr.push(quiz.quiz_id);
                        quizArr.push(quiz);
                    }
                })

                setAssignments(quizArr);

                let newPayload = {
                    course_id: payload.course_id,
                    quiz_id_arr: quizIDArr,
                }
                getAssignmentDetails(newPayload);
            } else {
                setLoading(false);
                setAssignments([]);
                // setMatrixCategories([]);
                setAssignmentDetails([]);
            }
        } catch (err) {
            setLoading(false);
            console.error("Error fetching quizzes:", err);
        }
    };


    const getAssignmentDetails = (payload) => {
        ApiRequestService({
            method: 'post',
            url: '/getQuizzesByIds',
            data: payload
        }).then(res => {
            if (res && res.data && res.data.data) {
                let arr = res.data.data;
                // arr.reverse();
                setAllAssignmentDetails(arr);
                handleUpdateAssignmentDetails(arr);
            }
        }).finally(() => {
            setLoading(false);
        })
    }

    const getSortedAssignments = (assignmentsArr) => {
        assignmentsArr.sort((assignA, assignB) => {
            const aValid = assignA.start_date && assignA.start_time && assignA.end_date && assignA.end_time;
            const bValid = assignB.start_date && assignB.start_time && assignB.end_date && assignB.end_time;

            if (!aValid && !bValid) return 0;
            if (!aValid) return 1;
            if (!bValid) return -1;

            const aMoment = moment(`${assignA.end_date} ${assignA.end_time}`, 'DD/MM/YYYY HH:mm:ss');
            const bMoment = moment(`${assignB.end_date} ${assignB.end_time}`, 'DD/MM/YYYY HH:mm:ss');

            return aMoment.diff(bMoment);
        });

        return assignmentsArr;
    };


    useEffect(() => {
        if (selectedSection) {
            let sectionData = sections.find(sec => sec.section_id === selectedSection);
            if (sectionData) {
                setSelectedSectionName(sectionData.section_name);
            }
        } else {
            setSelectedSectionName("");
        }
    }, [selectedSection])

    const handleCourseSelect = (_, value) => {
        setSelectedCourse(null);
        setSelectedSection(null);
        setSelectedSubsection(null);
        setAssignments([]);
        setAssignmentDetails([]);
        setMatrixCategories([]);
        if (value === null || value === undefined) return;
        setSelectedCourse(value);
        // getAssignments({
        //     course_id: value.id,
        // })
    }

    const handleSectionSelect = (event) => {
        let value = event.target.value;
        setSelectedSection(value)
        setSelectedSubsection(null);
        setAssignments([]);
        setMatrixCategories([]);
        setAssignmentDetails([]);
        if (value === null || value === undefined) return;
        let tempSection = sections?.find(sec => sec.section_id === value);
        if (tempSection) {
            setHasSubSections(tempSection.enable_subsection)
            if (tempSection.enable_subsection) {
                getSubsections({
                    course_id: selectedCourse.id,
                    section_Id: value,
                });
            }
        }
        
        getAssignments({
            semesterID: selectedSemester.id,
            archiveMode: true, // Have to add this so it works in go backend
            course_id: selectedCourse.id,
            section_Id: value,
        })

        getMatrixCategories({
            course_id: selectedCourse.id,
            section_id: value,
        })
    }

    const handleSubsectionSelect = (event) => {
        let value = event.target.value;
        setSelectedSubsection(value);
        setAssignments([]);
        setMatrixCategories([]);
        setAssignmentDetails([]);
        if (value === null || value === undefined) return;

        // Instead of getting assignmets again filter the assignmenst based on section and subsection
        console.debug("allAssignmentDetails>>??", allAssignmentDetails)
        let tempAssignmentDetails = [];

        allAssignmentDetails.forEach(assignDetail => {
            if (
                assignDetail.sections_list &&
                assignDetail.sections_list.some(
                    sect => sect.id === selectedSection && sect.subsection_id === value
                )
            ) {
                tempAssignmentDetails.push(assignDetail);
            }
        });
        handleUpdateAssignmentDetails(tempAssignmentDetails)
        // setAssignmentDetails(tempAssignmentDetails);
        // getAssignments({
        //     course_id: selectedCourse.id,
        //     section_Id: selectedSection,
        //     subsection_id: value,
        // });
    }

    const getSubsections = (payload) => {
        ApiRequestService({
            method: 'post',
            url: '/getAllSubSections',
            data: payload
        }).then(res => {
            if (res.data && res.data.data && res.data.data.subsection_names != null && res.data.data.subsection_names.length > 0) {
                console.debug("res.data.data.subsection_names>>??", res.data.data.subsection_names)
                setSubsections(res.data.data.subsection_names);
            } else {
                setSubsections([]);
            }
        })
    }

    const handleSubjectSelect = (_, value) => {
        setTopics(null);
        setCategories(null);
        setSelectedSubject(null);
        setSelectedTopic(null);
        setSelectedCategories(null);
        if (value == null) return;
        setSelectedSubject(value);
        getTopics({
            subject_id: value.id
        })
    }

    const handleTopicSelect = (_, value) => {
        setCategories(null);
        setSelectedTopic(null);
        setSelectedCategories(null);
        if (value == null) return;
        setSelectedTopic(value);
        getCategories({
            subject_id: value.data.subject_id,
            topic_id: value.data.topic_id
        })
    }

    const handleCategoriesSelect = (_, values) => {
        setSelectedCategories(null);
        if (values == null) return;
        let newSelectedCategories = [...values];
        setSelectedCategories(newSelectedCategories);
    }

    /*  useEffect(() => {
         if (courseMatrixCategories && courseMatrixCategories.length) {
             if (matrixCategories && matrixCategories.length) {
                 console.debug("matrixCategories, courseMatrixCategories >>??", matrixCategories, courseMatrixCategories);
                 // TODO add the missing categories in matrixCategories FROM courseMatrixCategories 
                 // clear the courseMatrixCategories state
                 // when adding missing ones look at the handleAddCategories
             }
         }
     }, [matrixCategories, courseMatrixCategories]) */

    useEffect(() => {
        if (courseMatrixCategories && courseMatrixCategories.length) {
            if (matrixCategories && matrixCategories.length) {
                console.debug("matrixCategories, courseMatrixCategories >>??", matrixCategories, courseMatrixCategories);

                // Find missing ones (by subject_id, topic_id, category_id)
                let newMatrixCategories = [...matrixCategories];

                courseMatrixCategories.forEach(courseCat => {
                    const alreadyExists = newMatrixCategories.some(cat =>
                        cat.subject_id === courseCat.subject_id &&
                        cat.topic_id === courseCat.topic_id &&
                        cat.category_id === courseCat.category_id
                    );

                    if (!alreadyExists) {
                        let matrixCat = {
                            ...courseCat,
                            key: `${courseCat.subject_id}_${courseCat.topic_id}_${courseCat.category_id}`,
                            columnDataArr: assignmentDetails.map(_ => null)
                        };
                        newMatrixCategories.push(matrixCat);
                    }
                });

                if (newMatrixCategories.length !== matrixCategories.length) {

                    newMatrixCategories.sort((catA, catB) => {

                        const subjectComparsion = catA.subject_name.localeCompare(catB.subject_name);
                        if (subjectComparsion !== 0) return subjectComparsion;

                        const topicComparison = catA.topic_name.localeCompare(catB.topic_name);
                        if (topicComparison !== 0) return topicComparison;
                        return catA.category_name.localeCompare(catB.category_name);
                    });

                    console.debug("newMatrixCategories>>??", newMatrixCategories);

                    setMatrixCategories(newMatrixCategories);
                }

            } else {

                courseMatrixCategories.sort((catA, catB) => {
                    const subjectComparsion = catA.subject_name.localeCompare(catB.subject_name);
                    if (subjectComparsion !== 0) return subjectComparsion;

                    const topicComparison = catA.topic_name.localeCompare(catB.topic_name);
                    if (topicComparison !== 0) return topicComparison;
                    return catA.category_name.localeCompare(catB.category_name);
                });

                setMatrixCategories(courseMatrixCategories);
            }
            // clear the courseMatrixCategories state
            setCourseMatrixCategories([]);
        }
    }, [courseMatrixCategories]);


    const getMatrixCategories = (payload) => {
        ApiRequestService({
            method: 'post',
            url: '/getMatrixCategories',
            data: payload
        }).then(res => {
            if (res && res.data && res.data.status === 0) { // success
                let tempCourseMatrixCategories = res.data.data ? res.data.data : [];
                setCourseMatrixCategories(tempCourseMatrixCategories);
            } else {
                setCourseMatrixCategories([]);
                console.debug("res", res);
            }
        })
    }

    const addMatrixCategories = (matrixCategoriesData) => {
        clearAllNotifications();
        let payload = [];
        matrixCategoriesData.forEach(matCat => {
            payload.push({
                course_id: selectedCourse.id,
                section_id: selectedSection,
                subject_id: matCat.subject_id,
                topic_id: matCat.topic_id,
                category_id: matCat.category_id,
            })
        });

        console.debug("payload>>??", payload);
        // return;
        ApiRequestService({
            method: 'post',
            url: '/addMatrixCategories',
            data: payload
        }).then(res => {
            if (res && res.data && res.data.status === 0) { // success
                NotificationManager.success("Successfully added the categories to matrix table");
            } else {
                console.debug("res", res);
                NotificationManager.error("Something went wrong");
            }
        })
    }

    const handleAddCategories = () => {
        if (selectedCategories && selectedCategories.length) {
            let newMatrixCategories = [...matrixCategories];

            selectedCategories.forEach(selectedCat => {
                let matrixCat = {
                    ...selectedCat.data,
                    subject_name: selectedSubject?.data.subject_name,
                    subject_color: selectedSubject?.data.subject_color,
                    subject_short: selectedSubject?.data.subject_short,
                    topic_name: selectedTopic?.data.topic_name,
                    topic_short: selectedTopic?.data.topic_short,
                    topic_color: selectedTopic?.data.topic_color,
                };

                matrixCat.key = `${matrixCat.subject_id}_${matrixCat.topic_id}_${matrixCat.category_id}`;
                matrixCat.columnDataArr = assignmentDetails.map(_ => null);

                const alreadyExists = newMatrixCategories.some(cat => cat.key === matrixCat.key);
                if (!alreadyExists) {
                    newMatrixCategories.push(matrixCat);
                }
            });

            newMatrixCategories.sort((catA, catB) => {
                const subjectComparsion = catA.subject_name.localeCompare(catB.subject_name);
                if (subjectComparsion !== 0) return subjectComparsion;

                const topicComparison = catA.topic_name.localeCompare(catB.topic_name);
                if (topicComparison !== 0) return topicComparison;
                return catA.category_name.localeCompare(catB.category_name);
            });

            setMatrixCategories(newMatrixCategories);
            addMatrixCategories(newMatrixCategories);
            setSelectedCategories([]);
        }
    };


    const handleDragStart = (index) => {
        setDraggedColIndex(index);
    };

    const handleDrop = (index) => {
        if (draggedColIndex === null || draggedColIndex === index) return;

        const newOrder = [...columnOrder];
        const fromIdx = newOrder.indexOf(draggedColIndex);
        const toIdx = newOrder.indexOf(index);

        newOrder.splice(fromIdx, 1);
        newOrder.splice(toIdx, 0, draggedColIndex);

        setColumnOrder(newOrder);
        setDraggedColIndex(null);
    };

    const handleAssignmentTagClick = (event, assignment) => {
        setAnchorEl(event.currentTarget);
        console.debug("event.currentTarget", event.currentTarget)
        // setShowAssignmentDetailModal(true);
        setSelectedAssignment({
            ...assignment,
        });
    }

    const handleCategoryCellClick = (cat, columnDataIndex) => {
        let assignmentData = assignmentDetails[columnDataIndex]
        //console.debug("assignmentData>>?", assignmentData)
        if (assignmentData && cat.key) {
            setPickedAssignment(assignmentData);
            let obj = cat.columnDataArr[columnDataIndex];
            setPickedCategory({
                ...cat,
                key: `${cat.subject_id}_${cat.topic_id}_${cat.category_id}`,
                ...obj,
                columnDataArr: null,
            });
            setShowCategoryModal(true);
        }
    }

    const handleViewFullDetailClick = () => {
        setShowAssignmentDetailModal(true);
    }

    const handleSearchCategories = (event) => {
        let str = event.target.value;
        setSearchText(str);
    }

    const handleAddAssignmentClick = () => {
        setShowNewAssignmentModal(true);
    }

    const onCompleteCreateAssignment = (newAssignment) => {
        let updatedAssignmentDetails = [...assignmentDetails];
        // check if new assignment is in the selected section, only the append else ignore
        console.debug("newAssignment>>??", newAssignment);

        updatedAssignmentDetails.push(newAssignment);
        handleUpdateAssignmentDetails(updatedAssignmentDetails);
    }

    const onSaveCategoryModal = (updatedAssignment) => {
        let index = assignmentDetails.findIndex(assign => assign.quiz_id === updatedAssignment.quiz_id);
        if (index > -1) {
            let updatedAssignmentDetails = [...assignmentDetails];
            updatedAssignmentDetails[index] = {
                ...updatedAssignment,
                isQuizAttended: false,
            };
            handleUpdateAssignmentDetails(updatedAssignmentDetails);
            setShowCategoryModal(false);
            handleDeleteUserDataForQuiz(updatedAssignment.quiz_id, false, false);
        }
    }

    const onSaveAssignment = (updatedAssignment) => {
        let index = assignmentDetails.findIndex(assign => assign.quiz_id === updatedAssignment.quiz_id);
        if (index > -1) {
            let updatedAssignmentDetails = [...assignmentDetails];
            updatedAssignmentDetails[index] = {
                ...updatedAssignment,
                isQuizAttended: false,
            };
            handleUpdateAssignmentDetails(updatedAssignmentDetails);
            handleDeleteUserDataForQuiz(updatedAssignment.quiz_id, false, false);
        }
    }

    const onUpdateQuiz = (updatedData) => {
        let index = assignmentDetails.findIndex(assign => assign.quiz_id === updatedData.quiz_id);
        if (index > -1) {
            let updatedAssignmentDetails = [...assignmentDetails];
            console.debug("updatedData>>??", updatedData)
            updatedAssignmentDetails[index].quiz_name = updatedData.quiz_name;
            updatedAssignmentDetails[index].start_date = updatedData.start_date;
            updatedAssignmentDetails[index].start_time = updatedData.start_time;
            updatedAssignmentDetails[index].end_date = updatedData.end_date;
            updatedAssignmentDetails[index].end_time = updatedData.end_time;
            updatedAssignmentDetails[index].status = updatedData.status;
            handleUpdateAssignmentDetails(updatedAssignmentDetails);
            if (selectedAssignment) { // update assignment popover
                let sortedAssignments = getSortedAssignments(updatedAssignmentDetails);
                const newIndex = sortedAssignments.findIndex(assign => assign.quiz_id === updatedData.quiz_id);
                console.debug("updatedAssignmentDetails[newIndex]>>??", updatedAssignmentDetails[newIndex])
                setSelectedAssignment(updatedAssignmentDetails[newIndex])

                // get the assignment-header-<quiz_id> doc

            }
        }
    }

    const generateRawDataUrl = (rawData) => {
        let url = `${window.location.origin}/${rawData.quiz_type === 1 ? "testScore" : "quizScore"}?qname=${rawData.quiz_name}&quiz_id=${rawData.quiz_id}&course_id=${rawData.course_id}&static=0&course_name=${selectedCourse.data.course_name}&course_indx=${selectedCourse.id}&is_anonymous=${rawData.is_anonymous}`;
        return url;
    }

    const onDeleteAssignment = () => {
        clearAllNotifications();
        setLoading(true);
        ApiRequestService({
            method: 'post',
            url: '/deleteQuiz',
            data: {
                quiz_id: selectedAssignment.quiz_id,
                course_id: selectedCourse.id,
            },
        }).then(res => {
            if (res && res.data) {
                if (res.data.message === "") {
                    let tempAssignments = [...assignments];
                    let assignIndex = tempAssignments.findIndex(assign => assign.quiz_id === selectedAssignment.quiz_id);
                    if (assignIndex > -1) {
                        tempAssignments.splice(assignIndex, 1);
                        setAssignments(assignments);
                    }

                    let tempAssignmentDetails = [...assignmentDetails];
                    let assignDetailIndex = tempAssignmentDetails.findIndex(assign => assign.quiz_id === selectedAssignment.quiz_id);
                    if (assignDetailIndex > -1) {
                        tempAssignmentDetails.splice(assignDetailIndex, 1);
                        setAssignmentDetails(tempAssignmentDetails);
                    }

                    NotificationManager.success("Successfully deleted the assignment");
                } else {
                    NotificationManager.error("Something went wrong");
                }
            }
        }).finally(() => {
            setLoading(false);
            setShowDeleteAssignment(false);
            setSelectedAssignment(null);
        })
    }

    const onDeleteCategory = () => {
        let srcCategory = rightClickedCategory;
        console.debug("onDeleteCategory>>??", srcCategory);

        let sourceAssignment = assignmentDetails[srcCategory.columnDataIndex];
        let categoryKey = srcCategory.key;

        const deletedSubcats = sourceAssignment.quiz_subcat_info
            ? sourceAssignment.quiz_subcat_info.filter(subcat => {
                let key = `${subcat.subject_id}_${subcat.topic_id}_${subcat.category_id}`;
                return key === categoryKey;
            })
            : [];

        sourceAssignment.quiz_delete_arr = deletedSubcats;

        // --- Remove category from JSON fields ---
        const removeFromJsonField = (fieldName) => {
            if (sourceAssignment[fieldName]) {
                let obj = JSON.parse(sourceAssignment[fieldName] || "{}");
                delete obj[categoryKey];
                sourceAssignment[fieldName] = JSON.stringify(obj);
            }
        };

        removeFromJsonField("category_mastery_count");
        removeFromJsonField("category_number_of_questions");
        removeFromJsonField("category_nocqc");
        removeFromJsonField("random_subcategory_order");
        removeFromJsonField("category_is_required");
        removeFromJsonField("category_position");

        // --- Remove from arrays ---
        if (Array.isArray(sourceAssignment.quiz_subcat_info)) {
            sourceAssignment.quiz_subcat_info = sourceAssignment.quiz_subcat_info.filter(subcat => {
                let key = `${subcat.subject_id}_${subcat.topic_id}_${subcat.category_id}`;
                return key !== categoryKey;
            });
        }

        if (Array.isArray(sourceAssignment.quiz_details)) {
            sourceAssignment.quiz_details = sourceAssignment.quiz_details.filter(detail => {
                let key = `${detail.subject_id}_${detail.topic_id}_${detail.category_id}`;
                return key !== categoryKey;
            });
        }

        // --- Reorder quiz_subcat_info and quiz_details ---
        let updatedSubcategories = [];

        const atFirstKeys = new Set();
        const atLastKeys = new Set();

        if (sourceAssignment.category_position) {
            Object.entries(JSON.parse(sourceAssignment.category_position)).forEach(([key, value]) => {
                if (value.category_at_begining) {
                    atFirstKeys.add(key);
                } else if (value.category_at_last) {
                    atLastKeys.add(key);
                }
            });
        }

        let middleSubcats = [];
        let lastSubcats = [];
        let order = 1;

        sourceAssignment.quiz_subcat_info.forEach(subcat => {
            const key = `${subcat.subject_id}_${subcat.topic_id}_${subcat.category_id}`;

            if (atFirstKeys.has(key)) {
                updatedSubcategories.push({
                    ...subcat,
                    order: order++,
                });
            } else if (atLastKeys.has(key)) {
                lastSubcats.push(subcat);
            } else {
                middleSubcats.push(subcat);
            }
        });

        middleSubcats.forEach(subcat => {
            updatedSubcategories.push({
                ...subcat,
                order: order++,
            });
        });

        lastSubcats.forEach(subcat => {
            updatedSubcategories.push({
                ...subcat,
                order: order++,
            });
        });

        // Apply reordered arrays
        sourceAssignment.quiz_subcat_info = [...updatedSubcategories];
        sourceAssignment.quiz_details = [...updatedSubcategories];
        sourceAssignment.sections_list = [];
        sourceAssignment.sections_delete_list = [];

        console.debug("sourceAssignment after delete >>", sourceAssignment);

        setLoading(true);
        handleSaveAssignment(sourceAssignment).then(result => {
            //console.debug("result>>??", result);
            setLoading(false);
            if (result.success) {
                setShowDeleteCategory(false);
                setContextMenuAnchorEl(null);
                NotificationManager.success("Successfully removed the category", "", 1000);
                let updatedAssignmentDetails = [...assignmentDetails];
                updatedAssignmentDetails[srcCategory.columnDataIndex] = {
                    ...sourceAssignment,
                    isQuizAttended: false,
                };
                handleUpdateAssignmentDetails(updatedAssignmentDetails);
                setRightClickedCategory(null);
                setTargetCategory(null);
                setContextMenuAnchorEl(null);
                setSourceCategory(null);
                setAction(null);
            } else {
                NotificationManager.error(result?.error, 4000);
            }
        });

    };

    const onCompleteCopyAssignment = (assignmentData) => {
        // console.debug("assignmentData>>??", assignmentData)
        setShowCopyQuiz(false);
        if (assignmentData.courseID === selectedCourse.id && assignmentData.sectionIDs.includes(selectedSection)) {
            setSelectedSubsection(null);
            setSelectedAssignment({ quiz_id: assignmentData.newQuizID });
            getAssignments({
                course_id: assignmentData.courseID,
                section_Id: selectedSection,
            })
        }
        NotificationManager.success("Successfully copied the assignment.")
    }

    const onDeleteMatrixCategoryComplete = (deletedCategoryObj) => {
        let tempMatrixCategories = [...matrixCategories];
        let deleteKey = `${deletedCategoryObj.subject_id}_${deletedCategoryObj.topic_id}_${deletedCategoryObj.category_id}`;
        let index = tempMatrixCategories.findIndex(mc => {
            let key = `${mc.subject_id}_${mc.topic_id}_${mc.category_id}`;
            return key === deleteKey;
        });
        if (index > -1) {
            tempMatrixCategories.splice(index, 1);
            setMatrixCategories(tempMatrixCategories);
            NotificationManager.success("Successfully deleted the category from matrix table", "", 2000);
        }
    }

    const handleSemesterChange = (semester) => {
        setSelectedSemester(semester);
        setIsOldSemester(semester.data.isCurrent === false);
        console.debug("semester>>??", semester, semester.data.isCurrent)
        getCourses(semester.id)
    }

    return (
        <SecureShow targetRole={1} >
            <div style={{
                padding: '0 2rem',
                marginTop: '-3.5rem',
            }}>

                <div style={{
                    display: 'flex',
                    justifyContent: 'flex-start',
                    alignItems: "center",
                    gap: '1rem',
                }}>
                    {/* <Typography
                        fontSize={20}
                        fontWeight={600}
                        sx={{
                            whiteSpace: 'nowrap',  // keep it in one line
                            width: 'fit-content',  // shrink-wrap the text
                        }}
                    >
                        Assignment Matrix
                    </Typography> */}
                    <div style={{width:"400px", display:"flex", justifyContent:'flex-start', alignItems:'flex-start', gap: "2px"}} >
                    <Tooltip
                        title={<Typography className='text-white' fontSize={14}>
                            {helpText.getHelpTextForKey('Semester Dropdown')}
                        </Typography>}
                        placement={'right'}
                        arrow
                    >
                        <span>
                            <BsInfoCircleFill color='#737373' size={14}
                                style={{
                                    flexShrink: 0,
                                    minWidth: "12px",
                                    minHeight: "12px",
                                    verticalAlign: "middle",
                                    cursor: "pointer",
                                }} />
                        </span>
                    </Tooltip>
                    <div style={{flex: 1}}>
                        <SFSemesterDropdown 
                            selectedSemester={selectedSemester}
                            onChange={handleSemesterChange}
                        />
                    </div>
                    </div>
                    <Autocomplete
                        disabled={loading}
                        disablePortal
                        // style={{ width: "100%" }}
                        options={courses ? courses.map(course => {
                            return {
                                id: course.course_id,
                                label: course.course_name,
                                data: course,
                                is_lti_enabled: course.is_lti_enabled,
                            }
                        }) : []}
                        getOptionLabel={(option) => {
                            let text = option.label;
                            if (option.data && option.data.is_lti_enabled) {
                                text += " (LTI Course)"
                            }
                            return text;
                        }}
                        sx={{ minWidth: 300 }}
                        value={selectedCourse}
                        onChange={handleCourseSelect}
                        isOptionEqualToValue={(option, value) => option.id === value.id}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Courses"
                                InputProps={{
                                    ...params.InputProps,
                                    sx: {
                                        background: "#fff",
                                        borderRadius: "8px",
                                    },
                                }}
                            />
                        )}
                    />
                    {/* Section List */}
                    <FormControl sx={{ width: "350px" }}>
                        <InputLabel id="section-list">Sections</InputLabel>
                        <Select
                            labelId="section-list"
                            id="section-list-select"
                            value={selectedSection || ""}
                            label="Sections"
                            onChange={handleSectionSelect}
                        >
                            {sections?.map((section, index) => {
                                return <MenuItem key={section.section_id} value={section.section_id}>
                                    {section.section_name}
                                </MenuItem>
                            })}
                        </Select>
                    </FormControl>

                    {/* Subsection List */}
                    {hasSubSections ?
                        <FormControl sx={{ width: "350px" }}>
                            <InputLabel id="subsection-list">Subsections</InputLabel>
                            <Select
                                labelId="subsection-list"
                                id="subsection-list-select"
                                value={selectedSubsection}
                                label="Subsections"
                                onChange={handleSubsectionSelect}
                                endAdornment={selectedSubsection && <IconButton
                                    style={{ marginRight: '8px' }}
                                    onClick={() => {
                                        setSelectedSubsection(null);
                                        handleUpdateAssignmentDetails(allAssignmentDetails);
                                    }} size="small" edge="end">
                                    <MdClear />
                                </IconButton>}
                            >
                                {subsections?.map((subsection, index) => {
                                    return <MenuItem key={subsection.subsection_id} value={subsection.subsection_id}>
                                        {subsection.subsection_name}
                                    </MenuItem>
                                })}
                            </Select>
                        </FormControl>
                        : null}

                    <Box component="fieldset" className='legends'>
                        <legend>Legend</legend>
                        {selectedCourse && selectedCourse.is_lti_enabled ? null :
                            <>
                                <SFTooltip text={helpText.getHelpTextForKey("Published")}>
                                    <div className='single-legend'>
                                        <IoCheckmarkCircle color='#80C75B' fontSize={20} />
                                        <div> - Published</div>
                                    </div>
                                </SFTooltip>
                                <SFTooltip text={helpText.getHelpTextForKey("Unpublished")}>
                                    <div className='single-legend'>
                                        <RiProhibited2Line color='#5D5D5D' fontSize={20} />
                                        <div> - Unpublished</div>
                                    </div>
                                </SFTooltip>
                            </>
                        }
                        <SFTooltip text={helpText.getHelpTextForKey("Missing Data")}>
                            <div className='single-legend'>
                                <FaExclamation color='red' fontSize={20} />
                                <div> - Missing Data</div>
                            </div>
                        </SFTooltip>
                        <SFTooltip text={helpText.getHelpTextForKey("Mastery, Level")}>
                            <div className='single-legend'>
                                <div className='mastery-box'>#</div>
                                <div> - Mastery, Level</div>
                            </div>
                        </SFTooltip>
                        {/* <SFTooltip text="Required number of correctly-answered questions in a row to get full credit for the assigned skill category.">
                                <div className='single-legend'>
                                    <FaHashtag color='#bb0000' fontSize={16} />
                                    <div> - Mastery Count</div>
                                </div>
                            </SFTooltip> */}
                        <SFTooltip text={helpText.getHelpTextForKey("Test, Questions")}>
                            <div className='single-legend'>
                                <div className='test-box'>#</div>
                                <div> - Test, Questions</div>
                            </div>
                        </SFTooltip>
                        {/* <SFTooltip text="Number of questions">
                                <div className='single-legend'>
                                    <FaHashtag color='#0004FF' fontSize={16} />
                                    <div> - No. of questions</div>
                                </div>
                            </SFTooltip> */}
                        <SFTooltip text={helpText.getHelpTextForKey("At First")}>
                            <div className='single-legend'>
                                <div class="triangle" style={{ borderLeftColor: "#34C759" }}></div>
                                <div> - At First</div>
                            </div>
                        </SFTooltip>
                        <SFTooltip text={helpText.getHelpTextForKey("At Last")}>
                            <div className='single-legend'>
                                <div class="triangle" style={{ borderLeftColor: "#FF3B30" }}></div>
                                <div> - At Last</div>
                            </div>
                        </SFTooltip>
                        <SFTooltip text={helpText.getHelpTextForKey("Free Choice")}>
                            <div className='single-legend'>
                                <div class="triangle" style={{ borderLeftColor: "#FF9500" }}></div>
                                <div> - Free Choice</div>
                            </div>
                        </SFTooltip>
                        <SFTooltip text={helpText.getHelpTextForKey("Practice Assignment")}>
                            <div className='single-legend'>
                                <TbTargetArrow color='#ec16d8' fontSize={20} />
                                <div> - Practice Assignment</div>
                            </div>
                        </SFTooltip>
                        {/*  <SFTooltip text="Delete category from assignment matrix table">
                            <div className='single-legend'>
                                <GoTrash color='#bb0000' />
                                <div> - Delete Category</div>
                            </div>
                        </SFTooltip> */}
                    </Box>
                </div>

                <div style={{ width: '100%', margin: '1rem 0rem', display: "flex", justifyContent: "space-between", }}>
                    <Grid container spacing={2} alignItems={'start'} flexWrap={'wrap'}>
                        {isOldSemester ? null : 
                            <React.Fragment>
                            <Grid item xs={2}>
                                <Autocomplete
                                    disablePortal
                                    size='small'
                                    options={subjects ? subjects.map(subject => {
                                        return {
                                            id: subject.subject_id,
                                            label: subject.subject_name,
                                            data: subject,
                                        }
                                    }) : []}
                                    value={selectedSubject}
                                    onChange={handleSubjectSelect}
                                    getOptionLabel={(option) => option.label}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Select Subject"
                                            InputProps={{
                                                ...params.InputProps,
                                                sx: {
                                                    borderRadius: "6px",
                                                },
                                            }}
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid item xs={2}>
                                <Tooltip
                                    title={!selectedSubject ?
                                        <Typography className="text-white" fontSize={14}>
                                            Please select a subject
                                        </Typography>
                                        : ""}
                                    arrow
                                    placement='top'
                                    disableHoverListener={!!selectedSubject}
                                >
                                    <span>
                                        <Autocomplete
                                            disablePortal
                                            size='small'
                                            options={topics ? topics.map(topic => {
                                                return {
                                                    id: topic.topic_id,
                                                    label: topic.topic_name,
                                                    data: topic,
                                                }
                                            }) : []}
                                            onChange={handleTopicSelect}
                                            value={selectedTopic}
                                            disabled={!selectedSubject}
                                            getOptionLabel={(option) => option.label}
                                            sx={{
                                                backgroundColor: !selectedSubject ? "#f5f5f5" : "white",
                                                opacity: !selectedSubject ? 0.6 : 1,
                                                "& .MuiInputBase-root": {
                                                    cursor: !selectedSubject ? "not-allowed" : "pointer",
                                                },
                                                "& .MuiInputBase-input": {
                                                    cursor: !selectedSubject ? "not-allowed" : "pointer",
                                                },
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Select Topic"
                                                    InputProps={{
                                                        ...params.InputProps,
                                                        sx: {
                                                            borderRadius: "6px",
                                                        },
                                                    }}
                                                />
                                            )}
                                        />
                                    </span>
                                </Tooltip>
                            </Grid>
                            <Grid item xs={2}>
                                <Tooltip
                                    title={!selectedTopic ?
                                        <Typography className="text-white" fontSize={14}>
                                            Please select a topic
                                        </Typography>
                                        : ""}
                                    arrow
                                    placement='top'
                                    disableHoverListener={!!selectedTopic}
                                >
                                    <span>
                                        <Autocomplete
                                            disablePortal
                                            size='small'
                                            options={mappedCategories}
                                            multiple
                                            filterSelectedOptions
                                            disabled={!selectedTopic}
                                            value={selectedCategories ? selectedCategories : []}
                                            onChange={handleCategoriesSelect}
                                            getOptionLabel={(option) => option.label}
                                            sx={{
                                                backgroundColor: !selectedTopic ? "#f5f5f5" : "white",
                                                opacity: !selectedTopic ? 0.6 : 1,
                                                "& .MuiInputBase-root": {
                                                    cursor: !selectedTopic ? "not-allowed" : "pointer",
                                                },
                                                "& .MuiInputBase-input": {
                                                    cursor: !selectedTopic ? "not-allowed" : "pointer",
                                                },
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Select Categories"
                                                    InputProps={{
                                                        ...params.InputProps,
                                                        sx: {
                                                            borderRadius: "6px",
                                                        },
                                                    }}
                                                />
                                            )}
                                        />
                                    </span>
                                </Tooltip>

                            </Grid>
                            </React.Fragment>
                        }
                        <Grid item xs={4}>
                            <div style={{ display: 'flex', justifyContent: "start", alignItems: "center", gap: "12px" }}>
                                {isOldSemester ? null : 
                                <Tooltip
                                    arrow
                                    disableHoverListener={selectedCategories && selectedCategories.length > 0}
                                    title={
                                        <Typography className="text-white" fontSize={14}>
                                            {helpText.getHelpTextForKey("Add Category To Matrix")}
                                        </Typography>
                                    }
                                >
                                    <span>
                                        <Button
                                            variant="contained"
                                            onClick={handleAddCategories}
                                            disabled={!selectedCategories || selectedCategories.length === 0}
                                        >
                                            {`Add Categor${selectedCategories && selectedCategories.length > 1 ? 'ies' : 'y'} To Matrix`}
                                        </Button>
                                    </span>
                                </Tooltip>
                                }
                                <DownloadMatrixCSV
                                    assignmentDetails={assignmentDetails}
                                    fileName={selectedCourse && selectedSectionName ?
                                        `${selectedCourse?.label}_${selectedSectionName}`
                                        : "empty"}
                                    matrixCategories={matrixCategories}
                                />
                            </div>
                        </Grid>
                        {isOldSemester ? null :
                        <Grid item xs={2}>
                            <div style={{ display: "flex", justifyContent: "flex-end", }}>
                                <Tooltip
                                    arrow
                                    disableHoverListener={selectedCourse !== null}
                                    title={
                                        <Typography className="text-white" fontSize={14}>
                                            Please pick a course.
                                        </Typography>
                                    }
                                >
                                    <span>
                                        <Button variant='contained' onClick={() => setShowImportModal(true)}
                                            disabled={selectedCourse === null || isOldSemester}
                                        >
                                            <div style={{display:"flex", justifyContent:"center", alignItems:"center", gap:'6px'}}>
                                                <BiImport fontSize={20} />
                                                <div>Import Assignments</div>
                                            </div>
                                        </Button>
                                    </span>
                                </Tooltip>
                            </div>
                        </Grid>
                        }
                    </Grid>
                </div>

                {/*  <div style={{ display: "flex", justifyContent: "space-between", alignItems: 'center', gap: "1rem", margin: "1.2rem 0rem", }}>
                        <Button variant='contained' onClick={() => setShowImportModal(true)}>
                            Import Assignments
                        </Button>
                </div> */}

                {/* <div>
                    <input type='checkbox' id="compact" onClick={() => setCompact(!compact)} />
                    <label htmlFor="compact">Compact</label>
                </div> */}
                {/* <div>
                    <input type='checkbox' id="compact" onClick={() => setCompact(!compact)} />
                    <label htmlFor="compact">Compact</label>
                </div> */}
                <div>
                    {rightClickedCategory && action ? <span className='ml-2 text-secondary' style={{
                        fontWeight: 'normal',
                        fontSize: '14',
                    }}> (Press ESCAPE to cancel the action)</span> : null}
                </div>

                {/* Table Start */}
                <div className='table-parent'>
                    {showArrow ?
                        <React.Fragment>
                            <div className='matrix-arrow left-arrow'>
                                <IconButton onClick={handleLeftArrowClick}>
                                    <FaArrowLeft fontSize={16} color='#fff' />
                                </IconButton>
                            </div>
                            <div className='matrix-arrow right-arrow'>
                                <IconButton onClick={handleRightArrowClick}>
                                    <FaArrowRight fontSize={16} color='#fff' />
                                </IconButton>
                            </div>
                        </React.Fragment> : null}
                    <div className='matrix-table-container assignment-table'>
                        {loading ? (
                            <div className='matrix-loader'>
                                <BeatLoader color={'#bb0000'} loading={true} size={15} />
                            </div>
                        ) : null}

                        <table className={`matrix-table ${matrixSizeClassNames[matrixSize]}`}>
                            <thead className='matrix-table-head'>
                                <tr className='cat-assign-header'>
                                    {/* <th colSpan={3}></th> */}
                                    <th colSpan={2}>
                                        <div className='category-header'>
                                            <div>Categories</div>
                                            <small>({matrixCategories?.length})</small>
                                        </div>
                                        <div className='compact-container'>
                                            {/* <input type='checkbox' id="compact" onClick={() => setCompact(!compact)} />
                                            <label htmlFor="compact">Compact</label> */}

                                            <FormControl>
                                                <RadioGroup
                                                    row
                                                    onChange={(_, val) => {
                                                        setMatrixSize(val);
                                                    }}
                                                    value={matrixSize}
                                                    aria-labelledby="demo-row-radio-buttons-group-label"
                                                    name="row-radio-buttons-group"
                                                >
                                                    <FormControlLabel value="small" control={<Radio size='small' />} label="Small" />
                                                    <FormControlLabel value="medium" control={<Radio size='small' />} label="Medium" />
                                                    <FormControlLabel value="large" control={<Radio size='small' />} label="Large" />
                                                </RadioGroup>
                                            </FormControl>
                                        </div>
                                    </th>
                                    <th colSpan={assignmentDetails?.length + 10 ?? 0}>
                                        <div className='assignment-header'>
                                            <div>Assignments
                                                <small>({assignments?.length})</small>
                                            </div>
                                            <div>
                                                <Tooltip
                                                    title={<Typography className='text-white' fontSize={14}>
                                                        {helpText.getHelpTextForKey("Assignments")}
                                                    </Typography>}
                                                    placement='top'
                                                    arrow
                                                >
                                                    <span>
                                                        <BsInfoCircleFill color='#737373' size={14}
                                                            style={{
                                                                flexShrink: 0,
                                                                minWidth: "12px",
                                                                minHeight: "12px",
                                                                verticalAlign: "middle",
                                                                cursor: "pointer",
                                                            }} />
                                                    </span>
                                                </Tooltip>
                                            </div>
                                        </div>
                                    </th>
                                </tr>
                                <tr className="matrix-row-header">
                                    <th className="matrix-row-cell">
                                        <div className='no-cell-top-border'></div>
                                        <div style={{ width: "100%" }}>
                                            No.
                                        </div>
                                    </th>
                                    {/*  <th className="matrix-row-cell">
                                        Subject Name
                                    </th>
                                    <th className="matrix-row-cell">
                                        Topic Name
                                    </th> */}
                                    <th className="matrix-row-cell" style={{
                                        minWidth: '400px'
                                    }} >
                                        <div className='category-cell-top-border'></div>
                                        <div style={{ width: '100%', }}>
                                            <TextField
                                                size='small'
                                                className='search-category-field'
                                                placeholder='Search Categories'
                                                value={searchText}
                                                onChange={handleSearchCategories}
                                                InputProps={{
                                                    startAdornment: (
                                                        <InputAdornment position="start">
                                                            <IoIosSearch fontSize={24} />
                                                        </InputAdornment>
                                                    )
                                                }}
                                                sx={{
                                                    width: '90%',
                                                    borderRadius: '8px',
                                                    '& .MuiInputBase-root': {
                                                        // height: compact ? '24px' : '34px',
                                                        height: categorySearchBarHeights[matrixSize],
                                                    }
                                                }}
                                            />
                                        </div>
                                    </th>
                                    {assignmentDetails?.map((assign, assignIndex) => {
                                        let isDateFilled = true;
                                        if (assign.start_date === "" || assign.start_date === null || assign.end_date === "" || assign.end_date === null) {
                                            isDateFilled = false;
                                        }

                                        let isLTIEnabled = false;
                                        if (selectedCourse && selectedCourse.is_lti_enabled) {
                                            isLTIEnabled = true;
                                        }

                                        return (
                                            <th
                                                key={assignIndex}
                                                className="matrix-row-cell"
                                                style={{ color: assignIndex === 0 ? '#bb0000' : 'black' }}
                                            >
                                                <div
                                                    className="assign-header-tag cat-cell"
                                                    id={`assignment-header-${assign.quiz_id}`}
                                                    onClick={(event) => {
                                                        // let assignDetail = assignmentDetails[assignIndex];
                                                        handleAssignmentTagClick(event, assign);
                                                    }}
                                                    aria-describedby={assignIndex}
                                                    style={{
                                                        color: "black",
                                                        // color: assign.quiz_type === 0 ? '#bb0000' : "#0004FF",
                                                        // backgroundColor: assign.quiz_type === 0 ? 'rgba(187, 0, 0, 0.05)' : 'rgba(0, 4, 255, 0.05)',
                                                    }}
                                                >
                                                    <div className='assign-cell-top-border'></div>
                                                    <div className="cat-cell-border"></div>
                                                    {assignIndex + 1}
                                                    {isLTIEnabled ?
                                                        !isDateFilled ?
                                                        <div className='status-icon'>
                                                            <FaExclamation color='red' />
                                                        </div> : null
                                                    : 
                                                        <div className='status-icon'>
                                                            {isDateFilled ? (assign.status === 1 ?
                                                                <IoCheckmarkCircle color='#80C75B' />
                                                                : <MdBlock color='#5d5d5d' />) :
                                                                <FaExclamation color='red' />
                                                            }
                                                        </div>
                                                    }
                                                    {assign.is_practice_assignment ? 
                                                        <div className='practice-assignment-icon'>
                                                            <TbTargetArrow color='#ec16d8' fontSize={14}/>
                                                        </div>
                                                    : null}
                                                </div>
                                            </th>
                                        )
                                    })}

                                    <th className="matrix-row-cell add-cell-container">
                                        <Button
                                            // size='small'
                                            variant='contained'
                                            color='primary'
                                            style={{ width: "100%", height: "100%", borderRadius: "0" }}
                                            disabled={
                                                isOldSemester ||
                                                selectedCourse === null || selectedSection === null
                                            }
                                            onClick={handleAddAssignmentClick}>
                                            + ADD
                                        </Button>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {matrixCategories && matrixCategories.filter(cat => cat.category_name.toLowerCase().includes(searchText.toLowerCase())).map((cat, index) => {
                                    // //console.debug("sourceCategory>>??", sourceCategory)
                                    let disabled = false;
                                    if (sourceCategory && sourceCategory.key !== cat.key) {
                                        disabled = true;
                                    }

                                    const colors = getColorFromIds(cat.subject_id, cat.topic_id);

                                    let showDeleteBtn = true;
                                    // console.debug("cat.columnDataArr>>??", cat.columnDataArr)
                                    if (cat.columnDataArr) {
                                        for (const catColData of cat.columnDataArr) {
                                            if (catColData !== null && catColData !== undefined && catColData.masteryCount !== undefined) {
                                                showDeleteBtn = false;
                                                break;
                                            }
                                        }
                                    }

                                    return (
                                        <tr className="matrix-row" key={index}>
                                            <td className="matrix-row-cell" style={{
                                                backgroundColor: disabled ? '#e6e6e6' : '#fafafa',
                                                filter: disabled ? 'grayscale(1.0)' : 'grayscale(0)',
                                            }}>{index + 1}</td>

                                            {/* <td className='matrix-row-cell text-align-left px-2' style={{minWidth:"200px"}}>
                                                {cat.subject_name}
                                            </td>
                                            <td className='matrix-row-cell text-align-left px-2' style={{minWidth:"200px"}}>
                                                {cat.topic_name}
                                            </td> */}

                                            <td className="matrix-row-cell category-width" style={{
                                                textAlign: 'left',
                                                backgroundColor: disabled ? '#e6e6e6' : '#fafafa',
                                                filter: disabled ? 'grayscale(1.0)' : 'grayscale(0)',
                                            }}>
                                                <div className='category-name-cell'>
                                                    <div style={{
                                                        display: "flex",
                                                        justifyContent: "space-between",
                                                        alignItems: "center",
                                                        width: "100%",
                                                        gap: ""
                                                    }}>
                                                        <div style={{
                                                            display: "flex",
                                                            justifyContent: "flex-start",
                                                            alignItems: "center"
                                                        }}>
                                                            <div className='stackable-icon-container'>
                                                                <Tooltip
                                                                    title={<Typography className='text-white' fontSize={14}>
                                                                        <div>Subject: {cat.subject_name}</div>
                                                                    </Typography>}
                                                                    arrow placement="top">
                                                                    <div className='stackable-icon stackable-subject-icon' style={{
                                                                        backgroundColor: cat?.subject_color ? cat.subject_color :getRandomColorForSubjectMatrix(),
                                                                        // borderColor: colors?.border,
                                                                        borderColor: 'transparent',
                                                                        color: "#fff",
                                                                    }}>
                                                                        {cat.subject_short ? cat.subject_short : (cat.subject_name ? generateLabelForName(cat.subject_name) : "")}
                                                                    </div>
                                                                </Tooltip>
                                                                <Tooltip
                                                                    title={<Typography className='text-white' fontSize={14}>
                                                                        <div>Topic: {cat.topic_name}</div>
                                                                    </Typography>}
                                                                    arrow placement="top">
                                                                    <div className='stackable-icon stackable-topic-icon' style={{
                                                                        'background-color': cat?.topic_color ? cat?.topic_color : getRandomColorForTopicMatrix(),
                                                                        borderColor: 'transparent',
                                                                        color: "#fff",
                                                                    }}>
                                                                        {cat.topic_short ? cat.topic_short : (cat.topic_name ? generateLabelForName(cat.topic_name) : "")}
                                                                    </div>
                                                                </Tooltip>
                                                            </div>
                                                            <div className='category-name'>
                                                                {cat.category_name}
                                                                {/* ({cat.subject_id}_{cat.topic_id}_{cat.category_id}) */}
                                                            </div>
                                                        </div>
                                                        {showDeleteBtn ?
                                                            <DeleteMatrixCategory
                                                                onDeleteComplete={onDeleteMatrixCategoryComplete}
                                                                category={cat}
                                                                courseID={selectedCourse?.id}
                                                                sectionID={selectedSection}
                                                            />
                                                            : null}
                                                    </div>
                                                </div>
                                            </td>

                                            {cat.columnDataArr && cat.columnDataArr.length ?
                                                cat.columnDataArr.map((columnData, columnDataIndex) => {

                                                    let backgroundColor = '';

                                                    let color = "transparent";
                                                    if (columnData) {
                                                        //console.debug("columnData>>??", columnData)
                                                        if (columnData.atFirst) {
                                                            color = "#34c759";
                                                        } else if (columnData.atLast) {
                                                            color = "#ff3b30"
                                                        } else if (columnData.freeChoice) {
                                                            color = "#ff9500"
                                                        }
                                                    }

                                                    let bgColor = '';
                                                    let borderColor = '';
                                                    let borderStyle = 'solid';
                                                    let disabled = false;
                                                    let isSrcCategory = false;

                                                    if (columnData) {
                                                        if (columnData.isTest && columnData.noOfQuestions > 0) {
                                                            backgroundColor = 'rgba(0, 4, 255, 0.05)'
                                                        } else if (!columnData.isTest && columnData.masteryCount > 0) {
                                                            backgroundColor = 'rgba(187, 0, 0, 0.05)'
                                                        }
                                                        if (columnData.isPracticeAssignment) {
                                                            backgroundColor = "rgba(236, 22, 216, 0.1)";
                                                        }
                                                    }

                                                    if (targetCategory && columnData) {
                                                        if (targetCategory.quiz_type === columnData.quiz_type && targetCategory.key === cat.key && targetCategory.columnDataIndex === columnDataIndex) {
                                                            borderColor = '#0D99FF';
                                                        }
                                                    }
                                                    // console.debug("rightClickedCategory>>??", rightClickedCategory, columnData);
                                                    if (rightClickedCategory && columnData) {
                                                        if (rightClickedCategory.quiz_type === columnData.quiz_type && rightClickedCategory.key === cat.key && rightClickedCategory.columnDataIndex !== columnDataIndex) {
                                                            // if (action === 'cut' || action === 'copy') {
                                                            //     bgColor = '#80C75B';
                                                            // }
                                                        } else {
                                                            if (action === 'cut' || action === 'copy') {
                                                                bgColor = '#f6f6f6';
                                                                // bgColor = '#e1e6ed';
                                                                disabled = true;
                                                            }
                                                        }

                                                        if (rightClickedCategory.quiz_type === columnData.quiz_type && rightClickedCategory.key === cat.key && rightClickedCategory.columnDataIndex === columnDataIndex) {
                                                            borderColor = '#0D99FF';
                                                            if (action === 'cut') {
                                                                borderStyle = 'dashed';
                                                            }
                                                            isSrcCategory = true;
                                                            disabled = false;
                                                        }
                                                    }

                                                    let textColor = "#bb0000";
                                                    if (columnData?.isTest) {
                                                        textColor = "#0004FF";
                                                    }
                                                    if (columnData?.isPracticeAssignment) {
                                                        textColor = "#ec16d8";
                                                    }

                                                    return (
                                                        <td key={columnDataIndex} className="matrix-row-cell">
                                                            <div className={`cat-cell  ${columnData !== null ? "cat-cell-content" : ""}
                                                                ${disabled ? 'cat-cell-disabled' : ''}
                                                            `}
                                                                style={{
                                                                    color: textColor,
                                                                    backgroundColor: bgColor,
                                                                }}
                                                                onClick={() => {
                                                                    console.debug("sourceCategory>>??", sourceCategory);
                                                                    if (!disabled) {
                                                                        if (sourceCategory === null) {
                                                                            handleCategoryCellClick(cat, columnDataIndex)
                                                                        } else {
                                                                            setTargetCategory({
                                                                                ...cat,
                                                                                ...columnData,
                                                                                columnDataIndex,
                                                                            })
                                                                        }
                                                                    }
                                                                }}
                                                                onContextMenu={e => {
                                                                    e.preventDefault();
                                                                    // console.debug("columnData>>??", columnData)
                                                                    if (action === null && (
                                                                        columnData === null || columnData === undefined || columnData?.masteryCount === undefined
                                                                    )) {
                                                                        return
                                                                    }
                                                                    // if (!disabled && !isSrcCategory && columnData.masteryCount) {
                                                                    if (!disabled && !isSrcCategory) {
                                                                        //console.debug("columnData>>??", columnData)
                                                                        if (action === null) {
                                                                            setRightClickedCategory({
                                                                                ...cat,
                                                                                ...columnData,
                                                                                columnDataIndex,
                                                                            });
                                                                            setContextMenuAnchorEl(e.currentTarget);
                                                                        } else {
                                                                            setTargetCategory({
                                                                                ...cat,
                                                                                ...columnData,
                                                                                columnDataIndex,
                                                                            })
                                                                        }
                                                                    }
                                                                }}
                                                            >
                                                                <div className={`cat-cell-border ${borderColor ? "cat-cell-border-animation" : ""}
                                                                `}
                                                                    style={{
                                                                        backgroundColor: backgroundColor,
                                                                        borderColor: borderColor,
                                                                        borderStyle: borderStyle,
                                                                    }}></div>

                                                                <div className='cat-cell-triangle' style={{
                                                                    borderLeftColor: color,
                                                                }}></div>
                                                                <span className='main-cell-content'>
                                                                    {columnData?.isTest ?
                                                                        columnData?.noOfQuestions
                                                                        :
                                                                        columnData?.masteryCount
                                                                    }
                                                                </span>
                                                                
                                                            </div>
                                                        </td>
                                                    )
                                                })
                                                : null}
                                            {/* <td className='matrix-row-cell'></td>
                                            <td className='matrix-row-cell'></td>
                                            <td className='matrix-row-cell'></td>
                                            <td className='matrix-row-cell'></td>
                                            <td className='matrix-row-cell'></td> */}
                                            <td className="matrix-row-cell add-cell"></td>
                                        </tr>

                                    )
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>


                {/* Legend */}
                {/* <h4 style={{ fontWeight: 'bolder', marginTop: "2rem" }}>
                    Legends:
                </h4> */}
                <div className='legend-container' style={{ marginTop: "2rem", marginBottom: '4rem' }}>
                    <div className='legend-col'>
                        <SFTooltip text="Assignment visible and accessible to students">
                            <div className='single-legend'>
                                <IoCheckmarkCircle color='#80C75B' fontSize={20} />
                                <div> - Published</div>
                            </div>
                        </SFTooltip>
                        <SFTooltip text="Assignment not visible or accessible to students">
                            <div className='single-legend'>
                                <RiProhibited2Line color='#5D5D5D' fontSize={20} />
                                <div> - Unpublished</div>
                            </div>
                        </SFTooltip>
                        <SFTooltip text="Assignment setup is incomplete. Please complete it to publish.">
                            <div className='single-legend'>
                                <FaExclamation color='red' fontSize={20} />
                                <div> - Incomplete Assignment</div>
                            </div>
                        </SFTooltip>
                    </div>
                    <div className='legend-col'>
                        <SFTooltip text={<div>Assignment in mastery mode in which student must correctly answer N = Mastery Count questions in a row to get credit for the skill category. <br /> For partially completed categories, partial credit is allowed only if the “Allow Partial Credit” is selected in the assignment settings.</div>}>
                            <div className='single-legend'>
                                <FaSquareFull color='#bb0000' fontSize={16} />
                                <div> - Mastery</div>
                            </div>
                        </SFTooltip>
                        <SFTooltip text="Required number of correctly-answered questions in a row to get full credit for the assigned skill category.">
                            <div className='single-legend'>
                                <FaHashtag color='#bb0000' fontSize={16} />
                                <div> - Mastery Count</div>
                            </div>
                        </SFTooltip>
                    </div>
                    <div className='legend-col'>
                        <SFTooltip text="Assignment in test mode in which students answer questions, like in a test or quiz.">
                            <div className='single-legend'>
                                <FaSquareFull color='#0004FF' fontSize={16} />
                                <div> - Test</div>
                            </div>
                        </SFTooltip>
                        <SFTooltip text="Number of questions">
                            <div className='single-legend'>
                                <FaHashtag color='#0004FF' fontSize={16} />
                                <div> - No. of questions</div>
                            </div>
                        </SFTooltip>
                    </div>
                    <div className='legend-col'>
                        <SFTooltip text="The category in the assignment is viewed first by the student and shown until mastery is achieved.">
                            <div className='single-legend'>
                                <div class="triangle" style={{ borderLeftColor: "#34C759" }}></div>
                                <div> - At First</div>
                            </div>
                        </SFTooltip>
                        <SFTooltip text="The category is viewed last by the student, after mastery is achieved by all other categories in the assignment.">
                            <div className='single-legend'>
                                <div class="triangle" style={{ borderLeftColor: "#FF3B30" }}></div>
                                <div> - At Last</div>
                            </div>
                        </SFTooltip>
                        <SFTooltip text="The category is not strictly required: it is in a list of N categories from which students must choose and master at least n<N categories to achieve full credit for the assignment.">
                            <div className='single-legend'>
                                <div class="triangle" style={{ borderLeftColor: "#FF9500" }}></div>
                                <div> - Free Choice</div>
                            </div>
                        </SFTooltip>
                        <SFTooltip text="Delete category from assignment matrix table">
                            <div className='single-legend'>
                                <GoTrash color='#bb0000' />
                                <div> - Delete Category</div>
                            </div>
                        </SFTooltip>
                    </div>
                </div>
            </div>

            {/* Copy assignment */}
            <CopyQuizDialog
                visible={showCopyQuiz}
                onHide={() => setShowCopyQuiz(false)}
                courses={courses}
                quizID={selectedAssignment?.quiz_id}
                isLTIEnabled={selectedCourse?.data?.is_lti_enabled}
                isMatrix={true}
                onCompleteCopyAssignment={onCompleteCopyAssignment}
            />

            {/* View raw data Modal */}
            <ViewRawDataModal
                visible={showViewRawData}
                url={showViewRawData ? generateRawDataUrl(selectedAssignment) : ''}
                handleCloseModal={() => setShowViewRawData(false)}
            />

            {/* Delete assignment dialog  */}
            <DeleteDialog
                showDialog={showDeleteAssignment}
                title={"Delete Assignment"}
                description={<div>
                    <div>
                        <strong>WARNING:</strong> You are about to erase a assignment. This will remove all student data associated with this assignment. You might want to consider taking a backup by downloading as CSV or excel.
                    </div>
                    <br />
                    <div>
                        Do you wish to proceed?
                    </div>
                </div>}
                onCancel={() => setShowDeleteAssignment(false)}
                onDelete={onDeleteAssignment}
            />

            {/* Delete category dialog */}
            <DeleteDialog
                showDialog={showDeleteCategory}
                title={"Delete Category"}
                description={<div><h4>Are you sure you want to delete this category?</h4></div>}
                onCancel={() => setShowDeleteCategory(false)}
                onDelete={onDeleteCategory}
            />

            {/* Assignment Popup */}
            {
                anchorEl ?
                    <AssignmentPopover
                        disableButtons={isOldSemester}
                        selectedCourse={selectedCourse}
                        anchorEl={anchorEl}
                        handleClose={() => setAnchorEl(null)}
                        assignment={selectedAssignment}
                        onUpdateQuiz={onUpdateQuiz}
                        checkIfAssignmentIsValid={checkIfAssignmentIsValid}
                        handleViewFullDetailClick={handleViewFullDetailClick}
                        handleViewRawDataClick={() => {
                            setShowViewRawData(true);
                            setAnchorEl(null);
                        }}
                        handleCopyAssignmentClick={() => {
                            setShowCopyQuiz(true);
                            setAnchorEl(null);
                        }}
                        handleDeleteAssignmentClick={() => {
                            setShowDeleteAssignment(true);
                            setAnchorEl(null);
                        }}
                    />
                    : null
            }

            {/* Add New Assignment  */}
            {
                showNewAssignmentModal ?
                    <NewAssignmentModal
                        selectedCourse={selectedCourse}
                        showModal={showNewAssignmentModal}
                        handleClose={() => setShowNewAssignmentModal(false)}
                        course_id={selectedCourse?.id}
                        onCompleteCreateAssignment={onCompleteCreateAssignment}
                    />
                    : null
            }

            {/* Category Modal */}
            {
                showCategoryModal ?
                    <CategoryModal
                        disableButtons={isOldSemester}
                        showModal={showCategoryModal}
                        handleClose={() => setShowCategoryModal(false)}
                        pickedAssignment={pickedAssignment}
                        pickedCategoryKey={pickedCategory.key}
                        pickedCategory={pickedCategory}
                        onSaveCategoryModal={onSaveCategoryModal}
                    />
                    : null
            }

            {/*Import assignments  */}
            <ImportAssignmentFromSemester
                visible={showImportModal}
                onHide={() => setShowImportModal(false)}
                onCompleteCopyQuiz={onCompleteCopyQuiz}
                courseID={selectedCourse?.id}
                fromMatrixPage={true}
                CurrentCourses={courses}
                CurrentSelectedCourse={selectedCourse?.data}
            />

            {
                showAssignmentDetailModal && selectedAssignment ?
                    <AssignmentDetailModal
                        semesterID={selectedSemester.id}
                        disableButtons={isOldSemester}
                        isNewAssignment={false}
                        showModal={showAssignmentDetailModal}
                        assignment={selectedAssignment}
                        handleClose={() => {
                            setAnchorEl(null);
                            setShowAssignmentDetailModal(false);
                        }}
                        onSaveAssignment={onSaveAssignment}
                        course_id={selectedCourse?.id}
                        handleResetPreview={handleDeleteUserDataForQuiz}
                        onAfterPreviewClick={onAfterPreviewClick}
                    />
                    : null
            }

            {/* {
                showNewAssignmentModal ?
                    <AssignmentDetailModal
                        showModal={showNewAssignmentModal}
                        isNewAssignment={true}
                        assignment={{
                            quiz_name: "",
                            quiz_type: 0,
                            allow_practice: true,
                            course_id: selectedCourse?.id,
                            randomize_categories: DEFAULT_RANDOMIZE_CATEGORIES,
                            mastery_condition: DEFAULT_MASTERY_COUNT,
                            maximum_attempted: DEFAULT_MAXIMUM_ATTEMPT,
                            lockoutN: DEFAULT_LOCKOUT,
                            NoCQC: DEFAULT_NOCQC,
                            start_date: "",
                            start_time: "",
                            end_date: "",
                            end_time: "",
                        }}
                        handleClose={() => {
                            setShowNewAssignmentModal(false);
                        }}
                        onSaveAssignment={onSaveAssignment}
                        course_id={selectedCourse?.id}
                    />
                    : null
            } */}

            <ContextMenu
                anchorEl={contextMenuAnchorEl}
                handleClose={() => {
                    if (action === null) {
                        setRightClickedCategory(null);
                        setSourceCategory(null);
                    } else {
                        setTargetCategory(null);
                    }

                    setContextMenuAnchorEl(null);
                }}
                action={action}
                handleActionClick={handleActionClick}
            />

        </SecureShow >
    );
}

class AssignmentPopover extends Component {

    debounceTimer = null;

    constructor(props) {
        super(props);
        this.state = {
            name: "",
            startDate: "",
            endDate: "",
            subCategories: [],
            status: 0,
            loading: false,
        }
    }

    componentDidMount() {
        if (this.props.assignment) {
            var startDateAndTime = this.props.assignment.start_date + ' ' + this.props.assignment.start_time;
            var endDateAndTime = this.props.assignment.end_date + ' ' + this.props.assignment.end_time;
            var resStartDate = '';
            var resEndDate = '';
            if (
                this.props.assignment.start_date !== null &&
                this.props.assignment.start_date !== ''
            ) {
                resStartDate = moment(startDateAndTime, 'DD-MM-YYYY HH-mm');
            }
            if (
                this.props.assignment.end_date !== null &&
                this.props.assignment.end_date !== ''
            ) {
                resEndDate = moment(endDateAndTime, 'DD-MM-YYYY HH-mm');
            }

            this.setState({
                name: this.props.assignment.quiz_name,
                startDate: resStartDate,
                endDate: resEndDate,
                subCategories: this.props.assignment.quiz_subcat_info,
                status: this.props.assignment.status,
            })
        }
    }

    clearAllNotifications = () => {
        NotificationManager.listNotify.forEach(n => {
            if (n && n.id) {
                NotificationManager.remove({ id: n?.id })
            }
        });
    }

    componentDidUpdate(prevProps) {
        if (this.props.assignment !== prevProps.assignment && this.props.assignment) {
            const startDateTime = `${this.props.assignment.start_date} ${this.props.assignment.start_time}`;
            const endDateTime = `${this.props.assignment.end_date} ${this.props.assignment.end_time}`;

            let resStartDate = null;
            let resEndDate = null;

            if (this.props.assignment.start_date) {
                resStartDate = moment(startDateTime, "DD-MM-YYYY HH:mm");
            }
            if (this.props.assignment.end_date) {
                resEndDate = moment(endDateTime, "DD-MM-YYYY HH:mm");
            }

            this.setState({
                name: this.props.assignment.quiz_name || "",
                startDate: resStartDate,
                endDate: resEndDate,
                subCategories: this.props.assignment.quiz_subcat_info || [],
                status: this.props.assignment.status || 0,
            });
        }
    }

    componentWillUnmount() {
        if (this.debounceTimer) {
            clearTimeout(this.debounceTimer);
        }
    }

    isValidDate = function (d) {
        return d instanceof Date && !isNaN(d);
    }

    handleChangeStartDate = (timeString, sDate, event) => {
        if (sDate !== null) {
            this.setState({
                startDate: moment(sDate),
            }, () => this.onStartDateChange())
        }
    }

    handleChangeEndDate = (eDate, id) => {
        if (eDate !== null) {
            let date = moment(eDate)
            if (id === "date") {
                date.set({ "h": 23, "m": 59 })
            }
            this.setState({
                endDate: date,
            }, () => this.onEndDateChange())
        }
    }

    handleNameChange = (e) => {
        const value = e.target.value;
        this.setState({ name: value });

        if (this.debounceTimer) {
            clearTimeout(this.debounceTimer);
        }

        this.debounceTimer = setTimeout(() => {
            this.updateQuiz();
        }, 500);
    };

    onStartDateChange = () => {
        this.clearAllNotifications();
        this.setState({ loading: true });
        let tempstartDate = this.state.startDate;
        if (tempstartDate === "") {
            NotificationManager.error("Start date should not be empty");
            return;
        }
        let startDate = tempstartDate.format('DD/MM/YYYY');
        tempstartDate = tempstartDate.format('DD/MM/YYYY HH:mm').split(' ');
        let startTime = tempstartDate[1];

        let endDate = "";
        let endTime = "00:00:00";
        let tempendDate = this.state.endDate;
        if (tempendDate) {
            endDate = tempendDate.format('DD/MM/YYYY');
            tempendDate = tempendDate.format('DD/MM/YYYY HH:mm').split(' ');
            endTime = tempendDate[1];
        }

        let payload = {
            quiz_id: this.props.assignment.quiz_id,
            quiz_name: this.state.name,
            start_date: startDate,
            start_time: startTime,
            end_date: endDate,
            end_time: endTime,
            status: this.state.status,
        }

        ApiRequestService({
            method: 'post',
            url: '/updateQuiz',
            data: payload,
        }).then(res => {
            this.setState({ loading: false });
            if (res && res.data) {
                if (res.data.message === "") {
                    NotificationManager.success("Updated Successfully");
                    this.props.onUpdateQuiz(payload);
                } else {
                    NotificationManager.error("Something went wrong");
                }
            }
        })
    }

    onEndDateChange = () => {
        this.clearAllNotifications();
        this.setState({ loading: true });
        let tempendDate = this.state.endDate;
        if (tempendDate === "") {
            NotificationManager.error("End date should not be empty");
            return;
        }

        let tempstartDate = this.state.startDate;
        let startDate = "";
        let startTime = "00:00:00";
        if (tempstartDate) {
            startDate = tempstartDate.format('DD/MM/YYYY');
            tempstartDate = tempstartDate.format('DD/MM/YYYY HH:mm').split(' ');
            startTime = tempstartDate[1];
        }

        let endDate = tempendDate.format('DD/MM/YYYY');
        tempendDate = tempendDate.format('DD/MM/YYYY HH:mm').split(' ');
        let endTime = tempendDate[1];

        let payload = {
            quiz_id: this.props.assignment.quiz_id,
            quiz_name: this.state.name,
            start_date: startDate,
            start_time: startTime,
            end_date: endDate,
            end_time: endTime,
            status: this.state.status,
        }
        ApiRequestService({
            method: 'post',
            url: '/updateQuiz',
            data: payload,
        }).then(res => {
            this.setState({ loading: false });
            if (res && res.data) {
                if (res.data.message === "") {
                    NotificationManager.success("Updated Successfully");
                    this.props.onUpdateQuiz(payload);
                } else {
                    NotificationManager.error("Something went wrong");
                }
            }
        })
    }

    updateQuiz = () => {
        this.clearAllNotifications();
        this.setState({ loading: true });
        let tempstartDate = this.state.startDate;
        let tempendDate = this.state.endDate;

        if (tempstartDate === "") {
            NotificationManager.error("Start date should not be empty");
            return;
        }
        if (tempendDate === "") {
            NotificationManager.error("End date should not be empty");
            return;
        }

        let startDate = tempstartDate.format('DD/MM/YYYY');
        tempstartDate = tempstartDate.format('DD/MM/YYYY HH:mm').split(' ');
        let startTime = tempstartDate[1];

        let endDate = tempendDate.format('DD/MM/YYYY');
        tempendDate = tempendDate.format('DD/MM/YYYY HH:mm').split(' ');
        let endTime = tempendDate[1];

        let payload = {
            quiz_id: this.props.assignment.quiz_id,
            quiz_name: this.state.name,
            start_date: startDate,
            start_time: startTime,
            end_date: endDate,
            end_time: endTime,
            status: this.state.status,
        }
        //console.debug("payload>>??", payload)
        ApiRequestService({
            method: 'post',
            url: '/updateQuiz',
            data: payload,
        }).then(res => {
            this.setState({ loading: false });
            if (res && res.data) {
                if (res.data.message === "") {
                    NotificationManager.success("Updated Successfully");
                    this.props.onUpdateQuiz(payload);
                } else {
                    NotificationManager.error("Something went wrong");
                }
            }
        })
    }

    render() {

        let startDateLocal = moment(this.state.startDate).toDate();
        let endDateLocal = moment(this.state.endDate).toDate();

        let isLTIEnabled = false;
        if (this.props.selectedCourse && this.props.selectedCourse.is_lti_enabled) {
            isLTIEnabled = true;
        }

        return (
            <>

                <Popover
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                    transformOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center',
                    }}
                    anchorEl={this.props.anchorEl}
                    open={Boolean(this.props.anchorEl)}
                    id={1}
                    style={{
                        top: "-6px"
                    }}
                    onClose={this.props.handleClose}
                    PaperProps={{
                        sx: {
                            width: '450px',
                            height: '185px',
                            borderRadius: '8px',
                            overflow: 'visible',
                            // mb: 5,
                            '&::after': {
                                content: '""',
                                position: 'absolute',
                                bottom: 0,
                                left: '50%',
                                transform: 'translate(-50%, 50%) rotate(45deg)',
                                width: 10,
                                height: 10,
                                bgcolor: 'background.paper',
                                zIndex: 0,
                            },
                        },
                    }}
                >
                    <div style={{ padding: "1rem" }} className='assignment-popover'>
                        <Grid container spacing={1}>
                            <Grid item xs={12}>
                                <TextField placeholder='Assignment name' size='small'
                                    value={this.state.name}
                                    disabled={this.props.disableButtons}
                                    onChange={this.handleNameChange}
                                    sx={{
                                        width: "100%",
                                        '& .MuiInputBase-root': {
                                            height: '30px',
                                            borderRadius: '4px'
                                        }
                                    }}
                                />
                            </Grid>
                            <Grid item xs={3}>
                                <div style={{ fontWeight: '500', fontSize: '14px' }}>Start Date:</div>
                                {/* <DatePicker
                                    displayMode="portrait"
                                    value={this.isValidDate(startDateLocal) ? startDateLocal : null}
                                    onChange={this.handleChangeStartDate}
                                    className='popup-picker'
                                    placeholder='Start Date'
                                /> */}
                                <SFDatePicker
                                    id="end-date"
                                    disabled={this.props.disableButtons}
                                    label="Start Date"
                                    placeholder={"MM/DD/YYYY"}
                                    value={this.isValidDate(startDateLocal) ? startDateLocal : null}
                                    onDatePickerChange={this.handleChangeStartDate}
                                    onDateChange={(dateText) => {
                                        this.setState({
                                            startDate: moment(dateText, "MM/DD/YYYY")
                                        }, () => this.onStartDateChange())
                                    }}
                                />
                            </Grid>
                            <Grid item xs={3}>
                                <div style={{ fontWeight: '500', fontSize: '14px' }}>Start Time:</div>
                                <TimePicker
                                    disabled={this.props.disableButtons}
                                    displayMode="portrait"
                                    value={this.isValidDate(startDateLocal) ? startDateLocal : null}
                                    onChange={this.handleChangeStartDate}
                                    className='hide-date-time-picker-label'
                                    placeholder='Start Time' />
                            </Grid>
                            <Grid item xs={3}>
                                <div style={{ fontWeight: '500', fontSize: '14px' }}>End Date:</div>
                                {/* <DatePicker
                                    displayMode="portrait"
                                    value={this.isValidDate(endDateLocal) ? endDateLocal : null}
                                    onChange={(_, date) => this.handleChangeEndDate(date, "date")}
                                    className='popup-picker' 
                                    placeholder='End Date' /> */}
                                <SFDatePicker
                                    disabled={this.props.disableButtons}
                                    id="end-date"
                                    label="End Date"
                                    placeholder={"MM/DD/YYYY"}
                                    value={this.isValidDate(endDateLocal) ? endDateLocal : null}
                                    onDatePickerChange={(date) => this.handleChangeEndDate(date, "date")}
                                    onDateChange={(dateText) => {
                                        let date = moment(dateText)
                                        date.set({ "h": 23, "m": 59 })
                                        this.setState({
                                            endDate: date,
                                        }, () => this.onEndDateChange())
                                    }}
                                />
                            </Grid>
                            <Grid item xs={3}>
                                <div style={{ fontWeight: '500', fontSize: '14px' }}>End Time:</div>
                                <TimePicker
                                    disabled={this.props.disableButtons}
                                    displayMode="portrait"
                                    value={this.isValidDate(endDateLocal) ? endDateLocal : null}
                                    onChange={(_, date) => this.handleChangeEndDate(date, "date")}
                                    className='hide-date-time-picker-label'
                                    placeholder='End Time' />
                            </Grid>
                            <Grid item xs={6}>
                                <div className='cursor-pointer'
                                    style={{ display: "flex", justifyContent: "flex-start", alignItems: "center", width: 'fit-content' }}
                                    onClick={(e) => {
                                        if (this.props.disableButtons) return;
                                        e.preventDefault();
                                        let val = this.state.status === 0 ? 1 : 0;

                                        let updatedAssignment = {
                                            ...this.props.assignment,
                                            quiz_name: this.state.name,
                                        }


                                        let isValid = this.props.checkIfAssignmentIsValid(updatedAssignment);
                                        if (isValid) {
                                            this.setState({ status: val }, () => this.updateQuiz());
                                        }

                                        // check if assignment is valid
                                        //console.debug("this.state>>??", this.state)
                                        /* if (this.state.name === "") {
                                            NotificationManager.error("Assignment name cannot be empty before publishing");
                                            return;
                                        }
                                        if (this.state.startDate === "" || this.state.endDate === "") {
                                            NotificationManager.error("Dates cannot be empty before publishing");
                                            return;
                                        }
                                        if (this.state.subCategories === null || this.state.subCategories === undefined || this.state.subCategories.length == 0) {
                                            NotificationManager.error("Please add atleast one category before publishing");
                                            return;
                                        }
                                        this.setState({ status: val }, () => this.updateQuiz()) */
                                    }}>
                                    {!isLTIEnabled ? <>
                                        <Toggle
                                            disabled={this.props.disableButtons}
                                            checked={this.state.status === 1}
                                            icons={false}
                                            onClick={e => e.stopPropagation()}
                                            onChange={(e) => e.stopPropagation()}
                                            className='custom-react-toggle'
                                        />
                                        <div>Publish</div>
                                    </>
                                        : null}
                                </div>
                            </Grid>
                            <Grid item xs={12}>
                                <div className='small-table-container'>
                                    <table className='small-table' style={{ width: "100%", borderCollapse: "collapse" }}>
                                        <thead>
                                            <tr>
                                                <th style={{ width: "50%", textAlign: "left" }}>Categories</th>
                                                <th style={{ width: "50%", textAlign: "left" }}>Subcategories</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.subCategories?.map((subCat, index) => (
                                                <tr key={index}>
                                                    <td>{subCat.category_Name || subCat?.category_name}</td>
                                                    <td>{subCat.subcategory_name}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </Grid>
                            <div className='popover-footer' style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                <div>
                                    <small className='popover-quizid'>Quiz ID: {this.props.assignment?.quiz_id}</small>
                                </div>
                                <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "center", gap: "1rem" }}>
                                    <div className='text-btn' onClick={this.props.handleViewFullDetailClick} style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        gap: "4px"
                                    }}>
                                        <FiEdit />
                                        <div>
                                            View Full Detail
                                        </div>
                                    </div>
                                    {this.props.disableButtons ? null :
                                        <div className='text-btn' onClick={this.props.handleCopyAssignmentClick} style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            gap: "4px"
                                        }}>
                                            <SFTooltip text="Copy Assignment">
                                                <span>
                                                    <FaRegCopy color='#bb0000' />
                                                </span>
                                            </SFTooltip>
                                        </div>
                                    }
                                    <div className='text-btn' onClick={this.props.handleViewRawDataClick} style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        gap: "4px"
                                    }}>
                                        <SFTooltip text="View Raw Data">
                                            <span>
                                                <LuFileText color='#bb0000' />
                                            </span>
                                        </SFTooltip>
                                    </div>
                                    {this.props.disableButtons ? null : 
                                        <div className='text-btn' onClick={this.props.handleDeleteAssignmentClick} style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            gap: "4px"
                                        }}>
                                            <SFTooltip text="Delete Assignment">
                                                <span>
                                                    <MdDelete color='#bb0000' />
                                                </span>
                                            </SFTooltip>
                                        </div>
                                    }
                                </div>
                            </div>

                        </Grid>
                    </div>
                </Popover>
            </>
        )
    }
}


const ContextMenu = ({ action, anchorEl, handleClose, handleActionClick }) => {

    const open = Boolean(anchorEl);

    return (
        <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            PaperProps={{
                sx: {
                    minWidth: '100px',
                },
            }}
        >
            <MenuItem className='menu-item' onClick={() => handleActionClick("cut")} disabled={action !== null}>
                <div className='context-list'>
                    <MdOutlineContentCut />
                    <div>Cut</div>
                </div>
            </MenuItem>
            <MenuItem className='menu-item' onClick={() => handleActionClick("copy")} disabled={action !== null}>
                <div className='context-list'>
                    <MdOutlineContentCopy />
                    <div>Copy</div>
                </div>
            </MenuItem>
            <MenuItem className='menu-item' onClick={() => handleActionClick("paste")} disabled={action === null}>
                <div className='context-list'>
                    <MdOutlineContentPaste />
                    <div>Paste</div>
                </div>
            </MenuItem>
            <MenuItem className='menu-item' onClick={() => handleActionClick("delete")}
                disabled={action !== null}
            >
                <div className='context-list'>
                    <MdDelete color='#bb0000' />
                    <div style={{ color: "#bb0000" }}>Delete</div>
                </div>
            </MenuItem>

        </Menu>
    )
}

export default AssignmentMatrix;

